// SignupOwner.js
import {
  getDatabase,
  ref,
  get,
  push,
  set,
  update,
  serverTimestamp,
} from "firebase/database";

import { useAuth } from "../contexts/AuthContext";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import PassengerCategorySelector from "./PassengerCategorySelector";
import "react-phone-input-2/lib/style.css";
import "../single-listing.css";
import {
  Button,
  Form,
  ProgressBar,
  Row,
  Col,
  Container,
  Image,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoClose } from "react-icons/io5";
import { TextField, Slider, Typography } from "@mui/material";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { FaMapPin, FaStar, FaEnvelope, FaChevronDown, FaChevronUp, FaTrash, FaSortAmountDownAlt, FaDollarSign, FaClock } from "react-icons/fa";
import { FaArrowRightLong, FaPeopleGroup, FaSort } from "react-icons/fa6";
import { CiShoppingTag, CiCalendar } from "react-icons/ci";
import { RxWidth } from "react-icons/rx";
import ListingGallery from "./ListingGallery";
import TwoMonthCalendar from "./TwoMonthCalendar";
import {
  getUserByID,
  getEventsByListingId,
  getReviewsByListingId,
  deleteReview,
  sendEmail,
  getCurrentUserDetails,
  InquiryReceivedEmailBody,
  getPlatformHourlyRate,
  sendSMS,
  GetVerifiedForBassBoat,
  getListingByID,
  getListingLockDatesByID,
  getBookingSourceData,
  getFullDayLockedDates,
  getLockedTimeConflict,
  getLockedTimeRangesForDate,
  getAvailableTimeSlotsForDate,
  getUserMetaByID,
  boatTypeRequiresRenterVerification,
  isRenterVerifiedForBoatType,
  getRenterVerificationStatus,
} from "./utils";
import { notifyNewBooking } from "./utils/adminNotifications";
import { notifyOwnerNewBooking, notifyOwnerReviewReceived } from "./utils/userNotifications";
import { getPassengerCounts, toPassengerCount } from "./utils/passengerCounts";
import { Alert } from "@mui/material";
import UserAvatar from "./UserAvatar";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Lightbox from "react-awesome-lightbox";
import { DesktopTimePicker } from "@mui/x-date-pickers/DesktopTimePicker";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { TbSteeringWheel } from "react-icons/tb";
import moment from "moment-timezone";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // Import UTC plugin
import customParseFormat from "dayjs/plugin/customParseFormat"; // Import customParseFormat plugin
import { ThreeDots } from "react-loader-spinner";
import PackageCard from "./PackageCard";
import PackageInstantBookModal from "./PackageInstantBookModal";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

const SingleListingLayout = ({ initialData, reviews }) => {
  const { signup, login, currentUser } = useAuth();
  const [cleared, setCleared] = useState(false);
  const [phone, setPhone] = useState("");
  const [listingReviews, setListingReviews] = useState("");
  const [listingLocation, setListingLocation] = useState("");
  const [userStatus, setUserStatus] = useState("");
  const [validPhone, setValidPhone] = useState(false);
  const [DeliveryService, setDeliveryService] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const [userMeta, setUserMeta] = useState(null);
  const [lightboxIsOpen, setLightboxIsOpen] = useState(false);
  const [isCaptain, setIsCaptain] = useState(false);
  const [listing, setListing] = useState([]);
  const [sameDayHours, setSameDayHours] = useState(0);
  const [isInstantBookAvailable, setIsInstantBookAvailable] = useState(false);
  const [instantBookError, setInstantBookError] = useState("");

  // Package instant booking state
  const [isPackageInstantBookModalOpen, setIsPackageInstantBookModalOpen] = useState(false);
  const [selectedPackageForInstantBook, setSelectedPackageForInstantBook] = useState(null);
  const [packageBookingDate, setPackageBookingDate] = useState(null);
  const [packageBookingTime, setPackageBookingTime] = useState(null);
  const [packageBookingError, setPackageBookingError] = useState("");

  const getSortLabel = (sort) => {
    switch (sort) {
      case 'price_asc': return "Price (Lowest)";
      case 'price_desc': return "Price (Highest)";
      case 'duration_asc': return "Duration (Shortest)";
      case 'duration_desc': return "Duration (Longest)";
      default: return "Price (Lowest)";
    }
  };

  const isPriceFilterActive = () => {
    return activePackageFilter.price.length === 2 &&
      (activePackageFilter.price[0] !== priceBounds.min ||
        activePackageFilter.price[1] !== priceBounds.max);
  };
  const [packageBookingLoading, setPackageBookingLoading] = useState(false);

  // Package filtering state
  const [activePackageFilter, setActivePackageFilter] = useState({
    guests: 1,
    date: null,
    price: [],
    duration: []
  });
  const [tempPackageFilters, setTempPackageFilters] = useState({
    guests: 1,
    date: null,
    price: [0, 5000],
    duration: []
  });
  const [sortOrder, setSortOrder] = useState("price_asc");
  const [tempSortOrder, setTempSortOrder] = useState("price_asc");
  const [showPackageSortPopover, setShowPackageSortPopover] = useState(false);
  const [showPackageDatePopover, setShowPackageDatePopover] = useState(false);
  const [showPackageGuestsPopover, setShowPackageGuestsPopover] = useState(false);

  // Price bounds derived from packages
  const priceBounds = React.useMemo(() => {
    if (!initialData?.fishingGuideDetails?.tripPackages) return { min: 0, max: 5000 };
    const prices = initialData.fishingGuideDetails.tripPackages.map(p => parseInt(p.basePrice) || 0);
    return {
      min: Math.min(...prices, 0),
      max: Math.max(...prices, 1000)
    };
  }, [initialData]);

  // Set default price range when loaded
  useEffect(() => {
    if (activePackageFilter.price.length === 0 && priceBounds.max !== 5000) {
      const fullRange = [priceBounds.min, priceBounds.max];
      setActivePackageFilter(prev => ({ ...prev, price: fullRange }));
      setTempPackageFilters(prev => ({ ...prev, price: fullRange }));
    }
  }, [priceBounds]);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const getLocationName = async (dropoff) => {
    try {
      // Check if dropoff exists and has lat/lng properties
      if (!dropoff || !dropoff.lat || !dropoff.lng) {
        console.log('Invalid location data');
        return;
      }

      const dropoffLat = dropoff.lat;
      const dropoffLlng = dropoff.lng;

      const dropOffResponse = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${dropoffLat},${dropoffLlng}&key=AIzaSyBfEcoyW9DM7QQWdV3oTjevrfyhX5n5qqg`
      );

      const dropOffdata = await dropOffResponse.json();
      const dropoffName =
        dropOffdata.results[0]?.formatted_address || "Location not found";
      setListingLocation(dropoffName);

      // Self-healing: Update DB if we had to fetch it
      if (dropoffName !== "Location not found" && initialData?.id) {
        const db = getDatabase();
        // We only want to update this specific field
        // Use update to avoid overwriting other fields
        update(ref(db, `listings/${initialData.id}`), {
          storageAddressText: dropoffName
        }).catch(err => console.error("Self-healing failed", err));
      }
    } catch (error) {
      console.error("Error fetching location name:", error);
      setListingLocation("Location not found");
    }
  };

  const handlePhoneChange = (newPhone) => {
    setPhone(newPhone);
    const validation = matchIsValidTel(newPhone);
    setValidPhone(validation);
    setSignUpData((prevData) => ({
      ...prevData,
      phone: newPhone,
    }));
  };
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);

  const handleEmailChange = (event) => {
    const enteredEmail = event.target.value;
    setEmail(enteredEmail);
    // Validate email using the specified pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    setValidEmail(emailPattern.test(enteredEmail));

    setSignUpData((prevData) => ({
      ...prevData,
      email: email,
    }));
  };

  const [loading, setLoading] = useState(false);

  const [deliveryPickupCheckbox, setDeliveryPickupCheckbox] = useState(false);
  const [trailerCheckbox, setTrailerCheckbox] = useState(false);
  const [captainCheckbox, setCaptainCheckbox] = useState(false);

  const [acknowledgement1, setAcknowledgement1] = useState(true);

  const handleAcknowledgement = (acknowledgementName) => {
    if (acknowledgementName === "acknowledgement1") {
      setAcknowledgement1((prev) => !prev);
    }
  };

  const [isBusinessInfoOpen, setIsBusinessInfoOpen] = useState(true);

  const toggleBusinessInfo = () => {
    setIsBusinessInfoOpen(!isBusinessInfoOpen);
  };

  const handleDeliveryPickupCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setDeliveryPickupCheckbox(isChecked);

    // Update inquiryData for Delivery/Pickup
    setInquiryData((prevData) => ({
      ...prevData,
      additionals: {
        ...prevData.additionals,
        deliveryPickup: isChecked ? 400 : 0, // Update the price accordingly
      },
    }));
  };

  const handleTrailerCheckbox = (event) => {
    const isChecked = event.target.checked;
    setTrailerCheckbox(isChecked);

    // setInquiryData((prevData) => ({
    //   ...prevData,
    //   additionals: {
    //     ...prevData.additionals,
    //     trailer: isChecked ? 100 : 0,
    //   },
    // }));
  };

  const handleCaptainCheckbox = (event) => {
    const isChecked = event.target.checked;
    setIsCaptain(isChecked);

    // Update inquiryData for Captain
    setInquiryData((prevData) => ({
      ...prevData,
      additionals: {
        ...prevData.additionals,
        captain: isChecked ? 1 : 0,
      },
    }));
  };

  async function handleSubmit(e) {
    e.preventDefault();

    const lockedTimeConflict = getInquiryLockedTimeConflict();
    if (lockedTimeConflict) {
      setError(getLockedTimeMessage(lockedTimeConflict));
      return;
    }

    setLoading(true);

    try {
      const newMessage = `Hello ${ownerDetails.firstName} ${ownerDetails.lastName
        }, 
        LineBreakI am reaching out to express my interest in <Link to='/listing/${listingId}>'${formData.listingTitle
        }</Link> and have a few inquiries regarding your listing.
        LineBreakLineBreak<span style="font-weight: bold;">My Requirements are:</span>LineBreak
        ${inquiryData.prefferedDate !== null
          ? `• My preffered date is, ${inquiryData.prefferedDate}LineBreak`
          : ""
        }
        ${inquiryData.prefferedTime !== null
          ? `• My preffered time is, ${inquiryData.prefferedTime}LineBreak`
          : ""
        }
        ${inquiryData.overnight > 0
          ? `• Duration, ${inquiryData.overnight} NightsLineBreak`
          : ""
        }
        ${inquiryData.sameDayHours > 0
          ? `• Duration, ${inquiryData.sameDayHours} Hours `
          : ""
        }
        ${inquiryData.sameDayMinutes > 0
          ? `${inquiryData.sameDayMinutes} MinutesLineBreak`
          : ""
        }
        ${inquiryData.children > 0
          ? `• ${inquiryData.children} ChildrenLineBreak`
          : ""
        }
        ${inquiryData.infants > 0
          ? `• ${inquiryData.infants} InfantsLineBreak`
          : ""
        }
        ${inquiryData.adults > 0
          ? `• ${inquiryData.adults} AdultsLineBreak`
          : ""
        }
        ${inquiryData.seniors > 0
          ? `• ${inquiryData.seniors} SeniorsLineBreak`
          : ""
        }
        ${inquiryData.total > 0 ? `• ${inquiryData.total} TotalLineBreak` : ""}
        LineBreakLineBreak<span style="font-weight: bold;">Comments:</span>LineBreak
        ${inquiryData.comments !== null
          ? `${inquiryData.comments}LineBreak`
          : ""
        }`;

      setMessage(newMessage);
      setError("");

      // Signup the user using email and password
      const userCredential = await signup(
        signUpData.email,
        signUpData.password
      );
      const userId = userCredential.user.uid; // Assuming Firebase auth returns a user object with uid
      await sendInquiry(true, userId);

      // Store user information in the Realtime Database under 'users' node
      const userRef = ref(getDatabase(), `users/${userId}`);
      await set(userRef, {
        firstName: signUpData.firstName,
        lastName: signUpData.lastName,
        email: signUpData.email,
        phone: signUpData.phone,
        role: "Renter",
        status: "Pending",
      });

      // Store userMeta information under 'userMeta' node with the same user ID
      const userMetaRef = ref(getDatabase(), `userMeta/${userId}`);
      await set(userMetaRef, {
        age: "12",
        userAnswers: {
          // Assuming multiChoiceQuestions and textQuestionAnswers are arrays of objects
          multiChoiceQuestions: {
            question: "question",
            answer: "answer", // Assuming selectedOptions is an array of selected options
          },
          textQuestions: {
            question: "question",
            answer: "answer",
          },
        },
        // Add other userMeta data fields as needed
      });
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  const handleAdd = (field) => {
    if (field === "sameDayHours") {
      setInquiryData((prevData) => ({
        ...prevData,
        sameDayHours: inquiryData.sameDayHours + 1,
      }));
      // if (sameDayHours >= 24) {
      //   setTrailerCheckbox(true);
      // }
      setInquiryData((prevData) => ({
        ...prevData,
        overnight: 0,
      }));
    }
  };

  const handleRemove = (field) => {
    if (field === "sameDayHours" && inquiryData.sameDayHours > 0) {
      setInquiryData((prevData) => ({
        ...prevData,
        sameDayHours: inquiryData.sameDayHours - 1,
      }));
      // if (sameDayHours >= 24) {
      //   setTrailerCheckbox(true);
      // }
    }
  };

  const sendInquiry = async (newUser, userId) => {
    if (
      acknowledgement1 != true ||
      (inquiryData.sameDayHours <= 0 && inquiryData.overnight <= 0) ||
      inquiryData.prefferedDate == null ||
      inquiryData.prefferedTime == null
    ) {
      setError("Please fill the fields and acknowledge before submitting");
      return;
    }

    setLoading(true);

    const newMessage = `Hello ${ownerDetails.firstName} ${ownerDetails.lastName
      }, I have an inquiry for ${formData.listingTitle}.${inquiryData.isPackageBooking ? ` I am interested in the trip package: ${inquiryData.packageId}.` : ""}
      LineBreakLineBreak<span style="font-weight: bold;">My Requirements are:</span>LineBreak
      ${inquiryData.prefferedDate !== null
        ? `• I require the boat preferably on, ${inquiryData.prefferedDate}LineBreak`
        : ""
      }
      ${inquiryData.prefferedTime !== null
        ? `• My preffered time is, ${inquiryData.prefferedTime}LineBreak`
        : ""
      }
      ${inquiryData.overnight > 0
        ? `• Duration, ${inquiryData.overnight} NightsLineBreak`
        : ""
      }
      ${inquiryData.sameDayHours > 0
        ? `• Duration, ${inquiryData.sameDayHours} Hours`
        : ""
      }
      ${inquiryData.sameDayMinutes > 0
        ? ` ${inquiryData.sameDayMinutes} MinutesLineBreak`
        : ""
      }
      ${inquiryData.total > 0 ? `• ${inquiryData.total} Total` : ""}
      ${inquiryData.children > 0 ? `• ${inquiryData.children} Children` : ""}
      ${inquiryData.infants > 0 ? `• ${inquiryData.infants} Infants` : ""}
      ${inquiryData.adults > 0 ? `• ${inquiryData.adults} Adults` : ""}
      ${inquiryData.seniors > 0 ? `• ${inquiryData.seniors} Seniors` : ""}
      ${inquiryData.comments.trim() !== ""
        ? `LineBreakLineBreak<span style="font-weight: bold;">Comments:</span>LineBreak ${inquiryData.comments}LineBreak`
        : ""
      }
      ${Boolean(inquiryData?.additionals?.captain) !== false ||
        Boolean(trailerCheckbox) !== false ||
        Boolean(DeliveryService) !== false
        ? `LineBreakLineBreak<span style="font-weight: bold;">Additionals:</span>LineBreak` +
        (Boolean(DeliveryService) === true
          ? "• Delivery & Pickup Service.LineBreak"
          : "") +
        (Boolean(trailerCheckbox) !== false
          ? "• Trailer Package.LineBreak"
          : "") +
        (Boolean(inquiryData?.additionals?.captain) !== false
          ? "• Captain Provided.LineBreakLineBreak"
          : "")
        : ""
      }
      `;
    const newMessageMobile =
      `Hello ${ownerDetails.firstName} ${ownerDetails.lastName}, I have an inquiry for ${formData.listingTitle}.${inquiryData.isPackageBooking ? ` I am interested in the trip package: ${inquiryData.packageId}.` : ""}\n\n` +
      (inquiryData.prefferedDate
        ? `• I require the boat preferably on ${inquiryData.prefferedDate}\n`
        : "") +
      (inquiryData.prefferedTime
        ? `• My preferred time is ${inquiryData.prefferedTime}\n`
        : "") +
      (inquiryData.overnight > 0
        ? `• Duration: ${inquiryData.overnight} Nights\n`
        : "") +
      (inquiryData.sameDayHours > 0
        ? `• Duration: ${inquiryData.sameDayHours} Hours\n`
        : "") +
      (inquiryData.total > 0 ? `• Total: ${inquiryData.total}\n` : "") +
      (inquiryData?.children > 0
        ? `• Children: ${inquiryData.children}\n`
        : "") +
      (inquiryData?.infants > 0 ? `• Infants: ${inquiryData.infants}\n` : "") +
      (inquiryData?.adults > 0 ? `• Adults: ${inquiryData.adults}\n` : "") +
      (inquiryData?.seniors > 0 ? `• Seniors: ${inquiryData.seniors}\n` : "") +
      (inquiryData.comments.trim() !== ""
        ? `\nComments:\n${inquiryData.comments}\n`
        : "") +
      (Boolean(DeliveryService) === true ||
        Boolean(trailerCheckbox) !== false ||
        Boolean(inquiryData?.additionals?.captain) !== false
        ? `\nAdditionals:\n` +
        (Boolean(DeliveryService) === true
          ? "• Delivery and pickup to 130 miles.\n"
          : "") +
        (Boolean(inquiryData?.additionals?.captain) !== false
          ? "• Captain Provided.\n"
          : "") +
        (Boolean(trailerCheckbox) !== false ? "• Trailer Package.\n" : "")
        : "");
    setMessage(newMessage);

    const database = getDatabase();

    const chatId1 = `${userId}_${formData.ownerId}`;
    const chatId2 = `${formData.ownerId}_${userId}`;

    const chatRef1 = ref(database, `chats/${chatId1}`);
    const chatRef2 = ref(database, `chats/${chatId2}`);

    if (userId === formData.ownerId) {
      alert("You cannot send a message to yourself");
      return;
    }

    try {
      const chatSnapshot1 = await get(chatRef1);
      const chatSnapshot2 = await get(chatRef2);

      let chatId;

      if (chatSnapshot1.exists()) {
        chatId = chatId1;
      } else if (chatSnapshot2.exists()) {
        chatId = chatId2;
      } else {
        chatId = chatId1;
      }

      // Corrected: Await the result of addInquiryData
      const inquiryId = await addInquiryData(chatId);

      const messageData = {
        senderId: userId,
        receiverId: formData.ownerId,
        message: newMessage,
        messageMobile: newMessageMobile,
        inquiryId: inquiryId,
        listingId: initialData.id,
        offerStatus: "pending",
        timestamp: serverTimestamp(),
      };

      if (userId === formData.ownerId) {
        alert("You cannot send a message to yourself");
        return;
      }

      if (chatSnapshot1.exists()) {
        const chatData = chatSnapshot1.val();
        const existingMessages =
          chatData && Array.isArray(chatData.messages) ? chatData.messages : [];

        const updates = {
          lastSenderId: userId,
          messages: [...existingMessages, messageData],
        };
        if (chatData.senderId === userId) {
          updates.senderReadStatus = 1;
          updates.receiverReadStatus = 0;
        } else {
          updates.senderReadStatus = 0;
          updates.receiverReadStatus = 1;
        }
        await update(chatRef1, updates);
      } else if (chatSnapshot2.exists()) {
        const chatData = chatSnapshot2.val();
        const existingMessages =
          chatData && Array.isArray(chatData.messages) ? chatData.messages : [];

        const updates = {
          lastSenderId: userId,
          messages: [...existingMessages, messageData],
        };
        if (chatData.senderId === userId) {
          updates.senderReadStatus = 1;
          updates.receiverReadStatus = 0;
        } else {
          updates.senderReadStatus = 0;
          updates.receiverReadStatus = 1;
        }
        await update(chatRef2, updates);
      } else {
        await set(chatRef1, {
          senderId: userId,
          receiverId: formData.ownerId,
          lastSenderId: userId,
          senderReadStatus: 1,
          receiverReadStatus: 0,
          messages: [messageData],
        });
      }

      const renterDataPromise = await getCurrentUserDetails();
      const listingDataPromise = await getListingByID(initialData.id);

      const [renterData, listingPromiseData] = await Promise.all([
        renterDataPromise,
        listingDataPromise,
      ]);

      const listingName = listingPromiseData.listingTitle;

      const bookingTitle =
        listingName + " - " + `${renterData.firstName} ${renterData.lastName}`;

      const database = getDatabase();
      const bookingRef = ref(database, `bookings`);

      const paymentRef = ref(database, `payments`);

      const userRef = ref(database, `users/${auth.currentUser.uid}`);

      const previousBookings = await get(userRef);
      let activeBookings;
      if (previousBookings.activeBookings) {
        activeBookings = previousBookings + 1;
        await update(userRef, { activeBookings });
      } else {
        activeBookings = 1;
        await update(userRef, { activeBookings });
      }

      // Use push to generate a new unique key
      const newBookingRef = push(bookingRef);

      // Get the key (ID) of the newly created node
      const newBookingId = newBookingRef.key;

      const newPaymentRef = push(paymentRef);

      // Get the key (ID) of the newly created node
      const newPaymentId = newPaymentRef.key;

      await set(newBookingRef, {
        listingId: initialData.id,
        renter: auth.currentUser.uid,
        owner: formData.ownerId,
        inquiryId: inquiryId,
        listingTitle: bookingTitle,
        priceOffered: 0,
        paymentId: newPaymentId,
        waiversFilled: {
          adult: 0,
          minor: 0,
        },
        timestamp: serverTimestamp(),
        status: "pending",
        ...getBookingSourceData(),
      });

      notifyNewBooking(bookingTitle, newBookingId).catch((err) =>
        console.error("Failed to create admin notification:", err)
      );
      notifyOwnerNewBooking(formData.ownerId, bookingTitle, newBookingId).catch(
        (err) => console.error("Failed to create owner notification:", err)
      );

      const ownerSubject = `New Inquiry Received`;
      const ownerEmail = ownerDetails.email;
      const renterName = userDetails.firstName + " " + userDetails.lastName;
      const ownerBodyData = await InquiryReceivedEmailBody(
        renterName,
        initialData.listingTitle
      );

      sendEmail(ownerEmail, ownerSubject, ownerBodyData);

      const ownerSmsBody = `You have received a booking inquiry.\n\nFollow the link to your dashboard to view your messages: ${process.env.REACT_APP_BASE_URL}/dashboard/inbox`;
      const ownerSmsResponse = sendSMS(ownerDetails.phone, ownerSmsBody);

      if (!newUser) {
        lastStep();
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setLoading(false);
    }
  };

  async function addInquiryData(chatId) {
    const database = getDatabase();
    const inquiryRef = ref(database, `inquiries`);

    try {
      // Use push to generate a new unique key
      const newInquiryRef = push(inquiryRef);

      // Get the key (ID) of the newly created node
      const newInquiryId = newInquiryRef.key;

      await set(newInquiryRef, {
        listingId: initialData.id,
        renter: auth.currentUser.uid,
        owner: formData.ownerId,
        chatId: chatId,
        inquiryData: { ...inquiryData, DeliveryService },
        timestamp: serverTimestamp(),
        status: "pending",
      });

      // Corrected: Return the ID of the newly created node
      return newInquiryId;
    } catch (error) {
      console.error("Error adding inquiry:", error);
      throw error; // Re-throw the error to handle it elsewhere if needed
    }
  }

  useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => { };
  }, [cleared]);

  const Navigate = useNavigate();

  const [step, setStep] = useState(1);

  const auth = useAuth();

  const [formData, setFormData] = useState({
    listingTitle: "",
    shortName: "",
    capacity: "",
    description: "",
    ownerId: "",
    featured_image: null,
    location: "",
    make: "",
    model: "",
    year: "",
    length: "",
    engineNumber: "",
    engineHorsepower: "",
    engineMaker: "",
    engineModel: "",
  });

  const [message, setMessage] = useState("");

  const [error, setError] = useState();
  const [errorMessage, setErrorMessage] = useState();

  const splitFeatures = () => {
    const features = initialData.features || [];
    const midpoint = Math.ceil(features.length / 2);
    const firstHalf = features.slice(0, midpoint);
    const secondHalf = features.slice(midpoint);
    return { firstHalf, secondHalf };
  };

  const { firstHalf, secondHalf } = splitFeatures();

  const [isCreateOfferModalOpen, setCreateOfferModalOpen] = useState(false);
  // State for passenger categories
  const [passengerCategories, setPassengerCategories] = useState({
    adults: 1,
    seniors: 0,
    minors: 0,
    infants: 0
  });

  // Handle passenger category change
  const handlePassengerCategoryChange = (categories, total) => {
    const safeCategories = {
      adults: toPassengerCount(categories?.adults, "adults"),
      seniors: toPassengerCount(categories?.seniors, "seniors"),
      minors: toPassengerCount(categories?.minors, "minors"),
      infants: toPassengerCount(categories?.infants, "infants"),
    };
    const safeTotal =
      toPassengerCount(total, "total") ||
      safeCategories.adults +
        safeCategories.seniors +
        safeCategories.minors +
        safeCategories.infants;

    setPassengerCategories(safeCategories);

    // Update inquiry data with passenger information
    setInquiryData(prev => ({
      ...prev,
      adults: safeCategories.adults,
      seniors: safeCategories.seniors,
      children: safeCategories.minors,
      infants: safeCategories.infants,
      total: safeTotal
    }));

    // Calculate price adjustments if needed
    if (inquiryData?.isPackageBooking) {
       const packageMaxGuests = inquiryData.packageMaxGuests || 1;
       const additionalPassengers = Math.max(0, safeTotal - packageMaxGuests);
       const pricing = parseFloat(inquiryData.packageBasePrice) || 0;
       
       if (additionalPassengers > 0) {
          const percentage = parseFloat(inquiryData.packageExtraPersonPercentage) || 0;
          const priceIncrease = (pricing * (percentage / 100)) * additionalPassengers;
          setInquiryData(prev => ({ ...prev, additionalPassengers, priceIncrease, adjustedPrice: pricing + priceIncrease }));
       } else {
          setInquiryData(prev => ({ ...prev, additionalPassengers: 0, priceIncrease: 0, adjustedPrice: pricing }));
       }
    } else if (initialData?.boatType === "Fishing Charter" && initialData?.pricing) {
      // Get the hourly rate
      const hourlyRate = parseFloat(initialData.pricing.hourlyRate) || 0;

      // Get the number of hours from inquiry data
      const inquiryHours = Number(inquiryData?.sameDayHours) || 0;
      const inquiryOvernight = Number(inquiryData?.overnight) || 0;

      // Calculate the base price based on hours selected
      let calculatedBasePrice = 0;

      if (inquiryHours > 0 && hourlyRate > 0) {
        // Check if there's a specific price for this hour duration
        const hourlyOption = initialData.pricing.hourlyOptions?.find(
          opt => Number(opt.hours) === inquiryHours
        );
        calculatedBasePrice = hourlyOption ? parseFloat(hourlyOption.price) : (hourlyRate * inquiryHours);
      } else if (inquiryOvernight > 0 && initialData.pricing.dailyOptions?.length > 0) {
        // Use daily option price
        const dailyOption = initialData.pricing.dailyOptions?.find(
          opt => Number(opt.days) === inquiryOvernight
        );
        calculatedBasePrice = dailyOption ? parseFloat(dailyOption.price) : 0;
      }

      // Ensure we have a valid base price
      if (calculatedBasePrice > 0) {
        const maxPassengers = parseInt(initialData.pricing.maxPassengers) || 6;
        const additionalPassengersAllowed = parseInt(initialData.pricing.additionalPassengersAllowed) || 10;
        const additionalPassengerPercentage = parseFloat(initialData.pricing.additionalPassengerPercentage) || 10;

        // Calculate additional passengers
        const additionalPassengers = Math.max(0, safeTotal - maxPassengers);

        if (additionalPassengers > 0) {
          // Calculate price increase for additional passengers based on the calculated base price (hours × rate)
          const priceIncrease = (calculatedBasePrice * (additionalPassengerPercentage / 100)) * additionalPassengers;
          const adjustedPrice = calculatedBasePrice + priceIncrease;

          setInquiryData(prev => ({
            ...prev,
            additionalPassengers,
            priceIncrease,
            adjustedPrice: adjustedPrice,
            basePrice: calculatedBasePrice
          }));
        } else {
          // Clear additional passenger charges when passenger count is below or equal to max
          setInquiryData(prev => ({
            ...prev,
            additionalPassengers: 0,
            priceIncrease: 0,
            adjustedPrice: null,
            basePrice: calculatedBasePrice
          }));
        }
      }
    }
  };

  const openCreateOfferModal = async () => {
    const listingBoatType = initialData.boatType;
    const requiresVerification =
      boatTypeRequiresRenterVerification(listingBoatType);
    let latestUser = userDetails;
    let latestMeta = userMeta;

    try {
      const userData = await getUserByID(auth.currentUser.uid);
      const meta = await getUserMetaByID(auth.currentUser.uid);
      latestUser = userData;
      latestMeta = meta;
      setUserDetails(userData);
      setUserMeta(meta);

      if (
        requiresVerification &&
        !isRenterVerifiedForBoatType(userData, meta, listingBoatType)
      ) {
        const userName = userData.firstName + " " + userData.lastName;
        const adminEmailBody = await GetVerifiedForBassBoat(userName);
        sendEmail(
          userData?.email,
          `${listingBoatType} Verification`,
          adminEmailBody
        );
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }

    if (auth.currentUser) {
      if (
        requiresVerification &&
        !isRenterVerifiedForBoatType(latestUser, latestMeta, listingBoatType)
      ) {
        setErrorMessage(
          <div>
            Please verify your account to rent {listingBoatType.toLowerCase()}s.
            If you don&apos;t, your account will be shown as unverified to the
            boat owner.
            <Button className="mt-2 d-block" href="/dashboard/get-verified">
              Get Verified
            </Button>
          </div>
        );
        setCreateOfferModalOpen(true);
      } else {
        setCreateOfferModalOpen(true);
        setError("");
      }
    }
  };

  const closeCreateOfferModal = () => {
    setCreateOfferModalOpen(false);
  };

  const handlePackageBook = (tripPackage) => {
    setInquiryData((prev) => ({
      ...prev,
      sameDayHours: parseInt(tripPackage.duration) || 0,
      total: parseInt(tripPackage.maxGuests) || 1,
      adults: parseInt(tripPackage.maxGuests) || 1,
      children: 0,
      infants: 0,
      seniors: 0,
      isPackageBooking: true,
      packageBasePrice: tripPackage.basePrice,
      packageExtraPersonPercentage: tripPackage.priceChangeOptions?.extraPersonPrice || 0,
      packageExtraPersonPriceType: tripPackage.priceChangeOptions?.extraPersonPriceType || 'percentage',
      packageId: tripPackage.name
    }));
    openCreateOfferModal();
  };

  const calculateEstimatedPricing = () => {
    if (inquiryData?.isPackageBooking) {
      let pricing = parseFloat(inquiryData.packageBasePrice) || 0;
      if (inquiryData.additionalPassengers > 0 && pricing > 0 && inquiryData.packageExtraPersonPercentage) {
        const extraVal = parseFloat(inquiryData.packageExtraPersonPercentage) || 0;
        let priceIncrease = 0;
        if (inquiryData.packageExtraPersonPriceType === 'flat') {
          priceIncrease = extraVal * inquiryData.additionalPassengers;
        } else {
          priceIncrease = (pricing * (extraVal / 100)) * inquiryData.additionalPassengers;
        }
        pricing = pricing + priceIncrease;
      }
      return pricing.toFixed(2);
    }

    if (
      inquiryData &&
      inquiryData.sameDayHours !== undefined &&
      inquiryData.overnight !== undefined
    ) {
      const inquiryHours = Number(inquiryData?.sameDayHours);
      const inquiryovernight = Number(inquiryData?.overnight);

      let pricing = 0;

      const filterHourlyPriceFromInitialData = (H) => {
        return Number(
          initialData?.pricing?.hourlyOptions?.filter(
            (P) => Number(P?.hours) === H
          )[0]?.price || 0
        );
      };

      const filterDailyPriceFromInitialData = (D) => {
        return Number(
          initialData?.pricing?.dailyOptions?.filter(
            (d) => Number(d?.days) === D
          )[0]?.price || 0
        );
      };

      const oneHourPriceIfAvailable =
        Number(initialData?.pricing?.hourlyRate) || 0;

      // Determine base pricing based on inquiry hours
      if (
        initialData?.pricing?.hourlyOptions?.length > 0 &&
        inquiryHours > 0 &&
        oneHourPriceIfAvailable !== 0
      ) {
        pricing =
          filterHourlyPriceFromInitialData(inquiryHours) ||
          oneHourPriceIfAvailable * inquiryHours;
      }

      // Apply overnight charges
      if (
        initialData?.pricing?.dailyOptions?.length > 0 &&
        inquiryovernight > 0
      ) {
        pricing = filterDailyPriceFromInitialData(inquiryovernight);
      }

      if (
        filterHourlyPriceFromInitialData(inquiryHours) === 0 &&
        filterDailyPriceFromInitialData(inquiryovernight) === 0 &&
        oneHourPriceIfAvailable !== 0
      ) {
        pricing = oneHourPriceIfAvailable * inquiryHours;
      }

      if (initialData?.boatType?.toLowerCase() === "kayak") {
        pricing *= inquiryData?.numberOfBoats;
      }
      if (initialData?.boatType?.toLowerCase() === "jetski") {
        pricing *= inquiryData?.numberOfBoats;
      }

      // For Fishing Charter boats, add additional passenger charges if applicable
      if (initialData?.boatType === "Fishing Charter") {
        // If we have additional passengers, calculate the price increase based on the calculated pricing (hours × rate)
        if (inquiryData?.additionalPassengers > 0 && pricing > 0) {
          const additionalPassengerPercentage = parseFloat(initialData?.pricing?.additionalPassengerPercentage) || 10;
          const priceIncrease = (pricing * (additionalPassengerPercentage / 100)) * inquiryData.additionalPassengers;
          pricing = pricing + priceIncrease;
        }
      }

      return pricing.toFixed(2);
    }
    return 0;
  };

  useEffect(() => {
    if (trailerCheckbox) {
      setInquiryData((prev) => ({
        ...prev,
        additionals: { ...prev.additionals, trailer: 1 },
      }));
    } else {
      setInquiryData((prev) => ({
        ...prev,
        additionals: { ...prev.additionals, trailer: 0 },
      }));
    }
  }, [trailerCheckbox]);

  const overnightText = () => {
    if (
      inquiryData &&
      inquiryData.overnight !== undefined &&
      (inquiryData.overnight > 0 || inquiryData.sameDayHours >= 24)
    ) {
      if (trailerCheckbox) {
        return `Including overnight trailer package.`;
      } else {
        return `Including overnight.`;
      }
    }
    return "";
  };

  const [ownerDetails, setOwnerDetails] = useState([]);

  useEffect(() => {
    if (initialData) {
      setFormData((prevData) => ({
        ...prevData,
        listingTitle: initialData.listingTitle || "",
        shortName: initialData.shortName || "",
        capacity: initialData.capacity || "",
        description: initialData.description || "",
        ownerId: initialData.ownerId || "",
        featured_image: initialData.featured_image || null,
        location: initialData.storageAddress || "",
        make: initialData.make || "",
        model: initialData.model || "",
        year: initialData.year || "",
        length: initialData.length || "",
        engineNumber: initialData.engineNumber || "",
        engineHorsepower: initialData.engineHorsepower || "",
        engineMaker: initialData.engineMaker || "",
        engineModel: initialData.engineModel || "",
      }));
    }

    if (initialData.images) {
      setImages([...initialData.images, initialData.featured_image]);
    }

    if (initialData.ownerId) {
      getUserByID(initialData.ownerId)
        .then((userDetails) => {
          setOwnerDetails(userDetails);
        })
        .catch((error) => {
          console.error("Error fetching owner details:", error);
        });
    }

    // Only call getLocationName if storageAddress exists
    if (initialData?.storageAddress) {
      if (initialData.storageAddressText) {
        setListingLocation(initialData.storageAddressText);
      } else {
        getLocationName(initialData.storageAddress);
      }
    }
  }, [initialData]);

  const [images, setImages] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const [inquiryData, setInquiryData] = useState({
    sameDayHours: 0,
    sameDayMinutes: 0,
    overnight: 0,
    prefferedDate: null,
    numberOfBoats: 1,
    prefferedTime: null,
    adults: 0,
    seniors: 0,
    children: 0,
    infants: 0,
    total: 0,
    comments: "",
    additionals: {
      deliveryPickup: 0,
      trailer: trailerCheckbox ? 1 : 0,
      captain: captainCheckbox ? 1 : 0,
    },
    isPackageBooking: false,
    packageBasePrice: 0,
    packageExtraPersonPercentage: 0,
    packageId: null,
  });

  console.log("dskladhf8asudf89afd", inquiryData);

  const [listingLockDates, setListingLockDates] = useState([]);
  const [listingLockDatesRaw, setListingLockDatesRaw] = useState(initialData?.lockDates || {});
  const [disabledDates, setDisabledDates] = useState([]);

  const getInquiryLockedTimeConflict = (data = inquiryData) => {
    return getLockedTimeConflict(
      listingLockDatesRaw || initialData?.lockDates,
      data?.prefferedDate,
      data?.prefferedTime,
      data?.sameDayHours,
      data?.sameDayMinutes,
      data?.overnight
    );
  };

  const getLockedTimeMessage = (conflict) => {
    return `This listing is locked on ${dayjs(conflict.date).format("MMMM D, YYYY")} from ${conflict.start} to ${conflict.end}. Please choose another time.`;
  };

  const parseTimeForPicker = (time) => {
    if (!time) return null;

    const parsed = dayjs(
      time,
      ["hh:mm A", "h:mm A", "hh:mm:a", "h:mm:a", "hh:mm a", "h:mm a"],
      true
    );

    if (parsed.isValid()) {
      return parsed;
    }

    const fallback = dayjs(`2000-01-01 ${time}`);
    return fallback.isValid() ? fallback : null;
  };

  const lockedTimeRangesForSelectedDate = getLockedTimeRangesForDate(
    listingLockDatesRaw || initialData?.lockDates,
    inquiryData?.prefferedDate
  );
  const selectedTimeConflict = getInquiryLockedTimeConflict();
  const availableTimeSlotsForSelectedDate = getAvailableTimeSlotsForDate(
    listingLockDatesRaw || initialData?.lockDates,
    inquiryData?.prefferedDate,
    inquiryData?.sameDayHours,
    inquiryData?.sameDayMinutes,
    { intervalMinutes: 60 }
  );

  // Check if instant booking is available based on lead time
  const checkInstantBookAvailability = () => {
    // Check if instant book is enabled
    const instantBookEnabled = initialData?.fishingGuideDetails?.calendarRules?.instantBook;

    if (!instantBookEnabled) {
      setIsInstantBookAvailable(false);
      return false;
    }

    // Get lead time requirement (in hours)
    const leadTime = initialData?.fishingGuideDetails?.calendarRules?.leadTime;

    if (!leadTime || !inquiryData?.prefferedDate || !inquiryData?.prefferedTime) {
      setIsInstantBookAvailable(false);
      return false;
    }

    const lockedTimeConflict = getInquiryLockedTimeConflict();
    if (lockedTimeConflict) {
      setIsInstantBookAvailable(false);
      setInstantBookError(getLockedTimeMessage(lockedTimeConflict));
      return false;
    }

    // Parse lead time (format: "X hours before")
    const leadTimeHours = parseInt(leadTime.match(/\d+/)?.[0] || 0);

    // Combine preferred date and time
    const preferredDateTime = dayjs(`${inquiryData.prefferedDate} ${inquiryData.prefferedTime}`);
    const currentDateTime = dayjs();

    // Calculate hours until trip
    const hoursUntilTrip = preferredDateTime.diff(currentDateTime, 'hour', true);

    // Check if booking meets lead time requirement
    if (hoursUntilTrip >= leadTimeHours) {
      setIsInstantBookAvailable(true);
      setInstantBookError("");
      return true;
    } else {
      setIsInstantBookAvailable(false);
      setInstantBookError(`This boat requires at least ${leadTimeHours} hours notice for instant booking. Please send an inquiry instead.`);
      return false;
    }
  };

  // Update instant book availability when date/time changes
  useEffect(() => {
    if (inquiryData?.prefferedDate && inquiryData?.prefferedTime) {
      checkInstantBookAvailability();
    }
  }, [inquiryData?.prefferedDate, inquiryData?.prefferedTime, initialData]);

  // Handle instant booking - create booking and go directly to payment
  const handleInstantBook = async () => {
    // Validate all required fields
    if (
      acknowledgement1 != true ||
      (inquiryData.sameDayHours <= 0 && inquiryData.overnight <= 0) ||
      inquiryData.prefferedDate == null ||
      inquiryData.prefferedTime == null
    ) {
      setError("Please fill all required fields and acknowledge before booking");
      return;
    }

    // Check if the current user is the boat owner
    if (auth.currentUser && initialData && auth.currentUser.uid === initialData.ownerId) {
      setError("You cannot book your own boat");
      // Show alert dialog
      alert("You cannot book your own boat");
      return;
    }

    // Validate instant book availability
    if (!checkInstantBookAvailability()) {
      setError(instantBookError || "Instant booking is not available for this date/time");
      return;
    }

    const lockedTimeConflict = getInquiryLockedTimeConflict();
    if (lockedTimeConflict) {
      setError(getLockedTimeMessage(lockedTimeConflict));
      return;
    }

    setLoading(true);
    setError("");

    try {
      const database = getDatabase();
      const bookingRef = ref(database, `bookings`);
      const paymentRef = ref(database, `payments`);

      // Create new booking
      const newBookingRef = push(bookingRef);
      const bookingId = newBookingRef.key;

      // Create new payment
      const newPaymentRef = push(paymentRef);
      const newPaymentId = newPaymentRef.key;

      // Calculate pricing
      const estimatedPrice = calculateEstimatedPricing();

      // Create booking data
      const bookingData = {
        renter: auth.currentUser.uid,
        owner: initialData.ownerId,
        inquiryId: null, // No inquiry for instant booking
        listingTitle: initialData.listingTitle,
        priceOffered: parseInt(estimatedPrice),
        listingId: initialData.id,
        paymentId: newPaymentId,
        totalWaivers: inquiryData.total || 0,
        waiversFilled: {
          adult: 0,
          minor: 0,
        },
        status: "pending",
        createdAt: serverTimestamp(),
        timestamp: serverTimestamp(),
        tripDate: inquiryData.prefferedDate,
        tripTime: inquiryData.prefferedTime,
        duration: {
          sameDayHours: Number(inquiryData.sameDayHours) || 0,
          sameDayMinutes: Number(inquiryData.sameDayMinutes) || 0,
          overnight: Number(inquiryData.overnight) || 0,
          text: inquiryData.overnight > 0
            ? `${inquiryData.overnight} Night${inquiryData.overnight > 1 ? 's' : ''}`
            : `${inquiryData.sameDayHours} Hour${inquiryData.sameDayHours > 1 ? 's' : ''}${inquiryData.sameDayMinutes > 0 ? ` ${inquiryData.sameDayMinutes} Minute${inquiryData.sameDayMinutes > 1 ? 's' : ''}` : ''}`
        },
        passengers: {
          adults: inquiryData.adults || 0,
          children: inquiryData.children || 0,
          infants: inquiryData.infants || 0,
          seniors: inquiryData.seniors || 0,
          total: inquiryData.total || 0,
        },
        additionals: inquiryData.additionals || {},
        instantBook: true, // Flag to indicate this is an instant booking
        comments: inquiryData.comments || "",
        ...getBookingSourceData(),
      };

      // Save booking to database
      await set(newBookingRef, bookingData);

      notifyNewBooking(initialData.listingTitle, bookingId).catch((err) =>
        console.error("Failed to create admin notification:", err)
      );
      notifyOwnerNewBooking(initialData.ownerId, initialData.listingTitle, bookingId).catch(
        (err) => console.error("Failed to create owner notification:", err)
      );

      // Update user's active bookings count
      const userRef = ref(database, `users/${auth.currentUser.uid}`);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();
      const activeBookings = (userData?.activeBookings || 0) + 1;
      await update(userRef, { activeBookings });

      setLoading(false);
      closeCreateOfferModal();

      // Navigate to payment page
      const queryParams = new URLSearchParams({ bookingId });
      Navigate(`/dashboard/booking-payment?${queryParams.toString()}`);
    } catch (error) {
      console.error("Error creating instant booking:", error);
      setError("Failed to create booking. Please try again.");
      setLoading(false);
    }
  };

  // Open package instant book modal
  const openPackageInstantBookModal = (tripPackage) => {
    if (!auth.currentUser) {
      // Redirect to login page with return URL
      Navigate(`/auth?redirect_to=${encodeURIComponent(`/listing/${initialData.id}/packages`)}`);
      return;
    }
    setSelectedPackageForInstantBook(tripPackage);
    setPackageBookingDate(null);
    setPackageBookingTime(null);
    setPackageBookingError("");
    setIsPackageInstantBookModalOpen(true);
  };

  // Close package instant book modal
  const closePackageInstantBookModal = () => {
    setIsPackageInstantBookModalOpen(false);
    setSelectedPackageForInstantBook(null);
    setPackageBookingDate(null);
    setPackageBookingTime(null);
    setPackageBookingError("");
  };

  // Handle package instant booking - create booking and go to payment
  const handlePackageInstantBook = async () => {
    if (!packageBookingDate || !packageBookingTime) {
      setPackageBookingError("Please select both date and time");
      return;
    }

    // Check if the current user is the boat owner
    if (auth.currentUser && initialData && auth.currentUser.uid === initialData.ownerId) {
      setPackageBookingError("You cannot book your own boat");
      // Show alert dialog
      alert("You cannot book your own boat");
      return;
    }

    // Validate date is within package availability range if specified
    if (selectedPackageForInstantBook?.availableDateRange?.startDate && selectedPackageForInstantBook?.availableDateRange?.endDate) {
      const selectedDate = dayjs(packageBookingDate);
      const startDate = dayjs(selectedPackageForInstantBook.availableDateRange.startDate);
      const endDate = dayjs(selectedPackageForInstantBook.availableDateRange.endDate);

      if (selectedDate.isBefore(startDate) || selectedDate.isAfter(endDate)) {
        setPackageBookingError(`Please select a date between ${selectedPackageForInstantBook.availableDateRange.startDate} and ${selectedPackageForInstantBook.availableDateRange.endDate}`);
        return;
      }
    }

    // Validate day is offered if daysOffered is specified
    if (selectedPackageForInstantBook?.daysOffered) {
      const dayName = dayjs(packageBookingDate).format('ddd');
      if (!selectedPackageForInstantBook.daysOffered[dayName]) {
        const offeredDays = Object.entries(selectedPackageForInstantBook.daysOffered)
          .filter(([_, isOffered]) => isOffered)
          .map(([day]) => day)
          .join(', ');
        setPackageBookingError(`This package is only available on: ${offeredDays}`);
        return;
      }
    }

    // Check lead time requirement
    const leadTime = initialData?.fishingGuideDetails?.calendarRules?.leadTime;
    if (leadTime) {
      const leadTimeHours = parseInt(leadTime.match(/\d+/)?.[0] || 0);
      const bookingDateTime = dayjs(`${dayjs(packageBookingDate).format('YYYY-MM-DD')} ${packageBookingTime}`);
      const currentDateTime = dayjs();
      const hoursUntilTrip = bookingDateTime.diff(currentDateTime, 'hour', true);

      if (hoursUntilTrip < leadTimeHours) {
        setPackageBookingError(`This listing requires at least ${leadTimeHours} hours notice for instant booking`);
        return;
      }
    }

    setPackageBookingLoading(true);
    setPackageBookingError("");

    try {
      const database = getDatabase();
      const bookingRef = ref(database, `bookings`);
      const paymentRef = ref(database, `payments`);
      const inquiryRef = ref(database, `inquiries`);

      // Create new booking
      const newBookingRef = push(bookingRef);
      const bookingId = newBookingRef.key;

      // Create new payment
      const newPaymentRef = push(paymentRef);
      const newPaymentId = newPaymentRef.key;

      // Create new inquiry with offerData for package bookings
      const newInquiryRef = push(inquiryRef);
      const inquiryId = newInquiryRef.key;

      // Parse duration from package (e.g., "4 hours" -> { sameDayHours: 4 })
      const durationText = selectedPackageForInstantBook.duration || "";
      let sameDayHours = 0;
      let overnight = 0;

      const hoursMatch = durationText.match(/(\d+)\s*hour/i);
      const nightsMatch = durationText.match(/(\d+)\s*night/i);
      const daysMatch = durationText.match(/(\d+)\s*day/i);
      const plainNumberMatch = durationText.match(/^(\d+)$/);

      if (hoursMatch) {
        sameDayHours = parseInt(hoursMatch[1]);
      }
      if (nightsMatch) {
        overnight = parseInt(nightsMatch[1]);
      }
      if (daysMatch && !hoursMatch) {
        overnight = parseInt(daysMatch[1]);
      }
      // If duration is just a plain number (e.g., "2"), treat as hours
      if (!hoursMatch && !nightsMatch && !daysMatch && plainNumberMatch) {
        sameDayHours = parseInt(plainNumberMatch[1]);
      }

      // Format date and time
      const formattedDate = dayjs(packageBookingDate).format("dddd, MMMM D, YYYY");
      const formattedTime = packageBookingTime;

      // Build duration text from parsed values
      const parsedDurationText = sameDayHours > 0
        ? `${sameDayHours} Hour${sameDayHours > 1 ? 's' : ''}`
        : overnight > 0
          ? `${overnight} Night${overnight > 1 ? 's' : ''}`
          : selectedPackageForInstantBook.duration || '';

      // Create offerData structure similar to regular bookings
      const offerData = {
        offeredDate: formattedDate,
        offeredTime: formattedTime,
        duration: parsedDurationText,
        arivingDateTime: `${formattedDate} ${formattedTime}`,
        offerPrice: parseInt(selectedPackageForInstantBook.basePrice),
        overnight: overnight,
        offeredHours: sameDayHours,
        pickupAddress: initialData?.storageAddress || "",
        pickupAddressString: initialData?.storageAddressText || "",
        dropOffAddress: initialData?.storageAddress || "",
        dropOffAddressString: initialData?.storageAddressText || "",
        captainCheckbox: false,
        trailerCheckbox: false,
        deliveryPickup: false,
        discount: 0
      };

      // Save inquiry data
      await set(newInquiryRef, {
        listingId: initialData.id,
        renter: auth.currentUser.uid,
        owner: initialData.ownerId,
        inquiryData: {
          prefferedDate: formattedDate,
          prefferedTime: formattedTime,
          sameDayHours: sameDayHours,
          overnight: overnight,
          estimatedPrice: parseInt(selectedPackageForInstantBook.basePrice),
          numberOfBoats: 1,
          adults: 1,
          children: 0,
          infants: 0,
          seniors: 0,
          total: 1,
          passengers: {
            adults: 1,
            children: 0,
            infants: 0,
            seniors: 0,
            total: 1,
          },
          comments: ""
        },
        offerData: offerData,
        status: "Accepted",
        timestamp: serverTimestamp()
      });

      // Create a chat message for the instant booking notification
      const chatId1 = `${auth.currentUser.uid}_${initialData.ownerId}`;
      const chatId2 = `${initialData.ownerId}_${auth.currentUser.uid}`;
      const chatRef1 = ref(database, `chats/${chatId1}`);
      const chatRef2 = ref(database, `chats/${chatId2}`);
      const chatSnapshot1 = await get(chatRef1);
      const chatSnapshot2 = await get(chatRef2);

      const instantBookMessage = `I have just instant booked your package: ${selectedPackageForInstantBook.name} for ${formattedDate} at ${formattedTime}.`;
      const messageData = {
        senderId: auth.currentUser.uid,
        receiverId: initialData.ownerId,
        message: instantBookMessage,
        messageMobile: instantBookMessage,
        timestamp: serverTimestamp(),
        inquiryId: inquiryId,
        listingId: initialData.id,
      };

      if (chatSnapshot1.exists()) {
        const chatData = chatSnapshot1.val();
        const existingMessages = Array.isArray(chatData.messages) ? chatData.messages : [];
        const updates = {
          lastSenderId: auth.currentUser.uid,
          messages: [...existingMessages, messageData],
        };
        if (chatData.senderId === auth.currentUser.uid) {
          updates.senderReadStatus = 1;
          updates.receiverReadStatus = 0;
        } else {
          updates.senderReadStatus = 0;
          updates.receiverReadStatus = 1;
        }
        await update(chatRef1, updates);
      } else if (chatSnapshot2.exists()) {
        const chatData = chatSnapshot2.val();
        const existingMessages = Array.isArray(chatData.messages) ? chatData.messages : [];
        const updates = {
          lastSenderId: auth.currentUser.uid,
          messages: [...existingMessages, messageData],
        };
        if (chatData.senderId === auth.currentUser.uid) {
          updates.senderReadStatus = 1;
          updates.receiverReadStatus = 0;
        } else {
          updates.senderReadStatus = 0;
          updates.receiverReadStatus = 1;
        }
        await update(chatRef2, updates);
      } else {
        await set(chatRef1, {
          senderId: auth.currentUser.uid,
          receiverId: initialData.ownerId,
          lastSenderId: auth.currentUser.uid,
          senderReadStatus: 1,
          receiverReadStatus: 0,
          messages: [messageData],
        });
      }


      // Create booking data with inquiryId
      const bookingData = {
        renter: auth.currentUser.uid,
        owner: initialData.ownerId,
        inquiryId: inquiryId, // Link to the created inquiry
        listingTitle: initialData.listingTitle,
        priceOffered: parseInt(selectedPackageForInstantBook.basePrice),
        listingId: initialData.id,
        paymentId: newPaymentId,
        totalWaivers: selectedPackageForInstantBook.maxGuests || 0,
        waiversFilled: {
          adult: 0,
          minor: 0,
        },
        status: "pending",
        createdAt: serverTimestamp(),
        timestamp: serverTimestamp(),
        tripDate: formattedDate,
        tripTime: formattedTime,
        duration: {
          sameDayHours: Number(sameDayHours) || 0,
          sameDayMinutes: 0,
          overnight: Number(overnight) || 0,
          text: parsedDurationText
        },
        passengers: {
          adults: 1,
          children: 0,
          infants: 0,
          seniors: 0,
          total: 1,
        },
        additionals: {},
        instantBook: true,
        packageBooking: true,
        packageDetails: {
          name: selectedPackageForInstantBook.name,
          duration: selectedPackageForInstantBook.duration,
          basePrice: selectedPackageForInstantBook.basePrice,
          maxGuests: selectedPackageForInstantBook.maxGuests,
          description: selectedPackageForInstantBook.description || "",
        },
        comments: `Package: ${selectedPackageForInstantBook.name}`,
        ...getBookingSourceData(),
      };

      // Save booking to database
      await set(newBookingRef, bookingData);

      notifyNewBooking(initialData.listingTitle, bookingId).catch((err) =>
        console.error("Failed to create admin notification:", err)
      );
      notifyOwnerNewBooking(initialData.ownerId, initialData.listingTitle, bookingId).catch(
        (err) => console.error("Failed to create owner notification:", err)
      );

      // Update user's active bookings count
      const userRef = ref(database, `users/${auth.currentUser.uid}`);
      const userSnapshot = await get(userRef);
      const userData = userSnapshot.val();
      const activeBookings = (userData?.activeBookings || 0) + 1;
      await update(userRef, { activeBookings });

      setPackageBookingLoading(false);
      closePackageInstantBookModal();

      // Navigate to payment page
      const queryParams = new URLSearchParams({ bookingId });
      Navigate(`/dashboard/booking-payment?${queryParams.toString()}`);
    } catch (error) {
      console.error("Error creating package instant booking:", error);
      setPackageBookingError("Failed to create booking. Please try again.");
      setPackageBookingLoading(false);
    }
  };

  const [signUpData, setSignUpData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  });


  const handleDateChange = (date, option) => {
    if (date == null) {
      // Handle the case where date is null
    } else {
      // Assuming option is a string indicating the option, like 'otherDateOption1'
      setInquiryData((prevData) => ({
        ...prevData,
        [option]: dayjs(date).format("dddd, MMMM D, YYYY"),
      }));
    }
  };

  // Handle date selection from the calendar - simplified for single date selection only
  const handleCalendarDateSelect = (date) => {
    // Format date for the inquiry form
    const formattedDate = dayjs(date).format("dddd, MMMM D, YYYY");

    // Update the preferred date in the inquiry form
    setInquiryData((prevData) => ({
      ...prevData,
      prefferedDate: formattedDate,
      // Reset overnight and set default hours for same-day booking
      overnight: 0,
      sameDayHours: 8 // Default to 8 hours for same-day booking
    }));

    // Automatically open the inquiry modal when a date is selected
    if (auth.currentUser) {
      setCreateOfferModalOpen(true);
    } else {
      // If user is not logged in, scroll to the inquiry form
      const inquirySection = document.getElementById('inquiryForm');
      if (inquirySection) {
        inquirySection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleTimeChange = (time, option) => {
    if (time == null) {
    } else {
      // Assuming option is a string indicating the option, like 'otherDateOption1'
      setInquiryData((prevData) => ({
        ...prevData,
        [option]: dayjs(time).format("hh:mm A"),
      }));
    }
  };

  const handleInquiryTextChange = (event, option) => {
    const text = event.target.value;

    if (text == null) {
    } else {
      // Assuming option is a string indicating the option, like 'otherDateOption1'
      setInquiryData((prevData) => ({
        ...prevData,
        [option]: text,
      }));
    }
  };

  const handleSignUpTextChange = (event, option) => {
    const text = event.target.value;

    if (text == null) {
    } else {
      setSignUpData((prevData) => ({
        ...prevData,
        [option]: text,
      }));
    }
  };

  const handleInquiryChange = (e, name, action) => {
    let updatedValue;

    setInquiryData((prevData) => ({
      ...prevData,
      estimatedPrice: calculateEstimatedPricing(),
    }));

    if (action === "add_circle") {
      updatedValue = inquiryData[name] + 1;
    } else if (action === "remove_circle") {
      updatedValue = Math.max(inquiryData[name] - 1, 0);
    } else {
      updatedValue = parseInt(e.target.value, 10) || 0;
    }

    // Check if 'overnight' is 0 before updating 'sameDayHours' and 'sameDayMinutes'
    if (name === "overnight" && updatedValue > 0) {
      setInquiryData((prevData) => ({
        ...prevData,
        overnight: updatedValue,
        sameDayHours: 0,
        sameDayMinutes: 0,
      }));
    } else if (name === "sameDayHours" || name === "sameDayMinutes") {
      setInquiryData((prevData) => ({
        ...prevData,
        overnight: 0,
        [name]: updatedValue,
      }));
    } else {
      setInquiryData((prevData) => ({
        ...prevData,
        [name]: updatedValue,
      }));
    }
  };

  const [hourlyRate, setHourlyRate] = useState(100);
  useEffect(() => {
    const platformPrices = async () => {
      try {
        const rateHourly = await getPlatformHourlyRate();
        setHourlyRate(rateHourly);
        if (initialData.pricing?.hourlyRate) {
          setHourlyRate(initialData.pricing?.hourlyRate);
        }
      } catch (error) {
        console.error(error);
      }
    };
    platformPrices();
  }, []);

  const [listingId, setListingId] = useState("");

  useEffect(() => {
    const { total } = getPassengerCounts(inquiryData);
    if (total !== inquiryData.total) {
      setInquiryData((prevData) => ({ ...prevData, total: total }));
    }

    setListingId(initialData.id);

    const fetchEvents = async () => {
      try {
        // Only fetch events if listingId is defined
        if (listingId) {
          const individualEvents = await getEventsByListingId(listingId);
          const filteredEvents = individualEvents.filter(
            (event) => event.status != "cancelled"
          );
          setCalendarEvents(filteredEvents);
        } else {
          setCalendarEvents([]);
        }

        // Only fetch reviews if initialData.id is defined
        if (initialData?.id) {
          const updatedReviews = await getReviewsByListingId(initialData.id);
          setListingReviews(updatedReviews);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
        setCalendarEvents([]);
      }
    };

    // Only fetch events if initialData is loaded
    if (initialData?.id) {
      fetchEvents();
    }
  }, [inquiryData, formData, initialData]);

  async function nextStep() {
    if (step === 4) {
      const lockedTimeConflict = getInquiryLockedTimeConflict();
      if (lockedTimeConflict) {
        setError(getLockedTimeMessage(lockedTimeConflict));
        return;
      }
    }
    setError("");
    setStep((prevStep) => prevStep + 1);
  }

  const lastStep = () => {
    if (
      initialData?.boatType?.toLowerCase() === "kayak".toLowerCase() ||
      initialData?.boatType?.toLowerCase() === "jetski".toLowerCase()
    ) {
      setStep(10);
    } else {
      setStep(9);
    }
  };

  const prevStep = () => {
    setStep((prevStep) => prevStep - 1);
  };

  // const events = [
  //   {
  //     id: 1,
  //     title: 'Event 1',
  //     start: new Date(2024, 0, 10),
  //     end: new Date(2024, 0, 15),
  //   },
  //   // Add more events as needed
  // ];

  const [calendarEvents, setCalendarEvents] = useState([]);

  const StarRating = ({ rating, onRatingChange }) => {
    const stars = [1, 2, 3, 4, 5];

    return (
      <div>
        {stars.map((star) => (
          <span
            key={star}
            onClick={() => onRatingChange(star)}
            style={{
              cursor: "pointer",
              color: star <= rating ? "gold" : "gray",
              fontSize: "26px",
            }}
          >
            &#9733;
          </span>
        ))}
      </div>
    );
  };

  // Calculate average rating from reviews
  const calculateAverageRating = () => {
    if (!listingReviews || listingReviews.length === 0) {
      return 0;
    }

    let totalRating = 0;
    let ratingCount = 0;

    listingReviews.forEach(review => {
      // Sum up all the rating categories
      const categoryRatings = [
        review["Listing Accuracy"],
        review["Itinerary & Experience"],
        review["Vessel & Equipment"],
        review["Departure & Return"],
        review["Value"],
        review["Communication"]
      ];

      // Filter out undefined values and calculate the average for this review
      const validRatings = categoryRatings.filter(rating => rating !== undefined && rating !== null);
      if (validRatings.length > 0) {
        const reviewAverage = validRatings.reduce((sum, rating) => sum + rating, 0) / validRatings.length;
        totalRating += reviewAverage;
        ratingCount++;
      }
    });

    return ratingCount > 0 ? totalRating / ratingCount : 0;
  };

  const [ReviewformData, setReviewFormData] = useState({

    review: "",
    listingAccuracy: 0,
    itineraryExperience: 0,
    vesselEquipment: 0,
    departureReturn: 0,
    value: 0,
    communication: 0,
  });

  const handleReviewInputChange = (e) => {
    const { name, value } = e.target;
    setReviewFormData({ ...ReviewformData, [name]: value });
  };

  const handleRatingChange = (category, rating) => {
    setReviewFormData({ ...ReviewformData, [category]: rating });
  };

  const initialFormData = {

    review: "",
    listingAccuracy: 0,
    itineraryExperience: 0,
    vesselEquipment: 0,
    departureReturn: 0,
    value: 0,
    communication: 0,
  };

  const resetReviewForm = () => {
    setReviewFormData({ ...initialFormData });
  };
  const handleReviewSubmit = async (e) => {
    e.preventDefault();

    const database = getDatabase();
    const reviewsRef = ref(database, `reviews/${initialData.id}`);

    try {
      // Generate a dynamic ID for the new review node
      const newReviewRef = push(reviewsRef);
      const newReviewId = newReviewRef.key;

      // Create the review data object
      const reviewData = {
        firstname: userDetails?.firstName || "",
        lastname: userDetails?.lastName || "",
        review: ReviewformData.review,
        timestamp: serverTimestamp(),
      };

      // Include rating categories in the review data
      [
        "Listing Accuracy",
        "Itinerary & Experience",
        "Vessel & Equipment",
        "Departure & Return",
        "Value",
        "Communication",
      ].forEach((category) => {
        reviewData[category] = ReviewformData[category];
      });

      // Add the review data to the new review node
      await set(newReviewRef, reviewData);

      const reviewerName = `${userDetails?.firstName || ""} ${userDetails?.lastName || ""}`.trim();
      notifyOwnerReviewReceived(
        initialData.ownerId,
        initialData.listingTitle,
        null,
        reviewerName
      ).catch((err) =>
        console.error("Failed to create owner review notification:", err)
      );

      const updatedReviews = await getReviewsByListingId(initialData.id);

      // Set the state with the updated reviews
      setListingReviews(updatedReviews);
      resetReviewForm();
    } catch (error) {
      console.error("Error adding review data to Firebase:", error);
      // Handle the error as needed
    }
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [reviewToDelete, setReviewToDelete] = useState(null);

  const handleDeleteReview = (reviewId) => {
    setReviewToDelete(reviewId);
    setShowDeleteModal(true);
  };

  const confirmDeleteReview = async () => {
    if (reviewToDelete) {
      try {
        await deleteReview(initialData.id, reviewToDelete);
        const updatedReviews = await getReviewsByListingId(initialData.id);
        setListingReviews(updatedReviews);
        setShowDeleteModal(false);
        setReviewToDelete(null);
      } catch (error) {
        console.error("Error deleting review:", error);
      }
    }
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setReviewToDelete(null);
  };

  const filteredPackages = React.useMemo(() => {
    if (!initialData?.fishingGuideDetails?.tripPackages) return [];

    let packages = [...initialData.fishingGuideDetails.tripPackages];

    // Filter: guests
    if (activePackageFilter.guests > 0) {
      packages = packages.filter(pkg => {
        const included = parseInt(pkg.maxGuests) || 1;
        const additional = parseInt(pkg.priceChangeOptions?.afterGuests) || 0;
        const totalMax = included + additional;
        return activePackageFilter.guests <= totalMax;
      });
    }

    // Filter: date
    if (activePackageFilter.date) {
      const selectedDate = dayjs(activePackageFilter.date);
      const formattedDate = selectedDate.format("YYYY-MM-DD");

      packages = packages.filter(pkg => {
        // 1. Check disabled dates (locked/booked)
        if (disabledDates && Array.isArray(disabledDates) && disabledDates.includes(formattedDate)) return false;

        // 2. Check package available date range
        if (pkg.availableDateRange?.startDate && pkg.availableDateRange?.endDate) {
          const startDate = dayjs(pkg.availableDateRange.startDate);
          const endDate = dayjs(pkg.availableDateRange.endDate);
          if (selectedDate.isBefore(startDate) || selectedDate.isAfter(endDate)) {
            return false;
          }
        }

        // 3. Check days offered
        if (pkg.daysOffered) {
          const dayName = selectedDate.format('ddd');
          if (!pkg.daysOffered[dayName]) {
            return false;
          }
        }

        return true;
      });
    }

    // Filter: duration (heuristic parsing)
    if (activePackageFilter.duration.length > 0) {
      packages = packages.filter(pkg => {
        const dur = parseInt(pkg.duration) || 0; // "4 hours" -> 4
        return activePackageFilter.duration.some(range => {
          if (range === 'half') return dur <= 5;
          if (range === 'full') return dur >= 6;
          return false;
        });
      });
    }

    // Filter: price
    if (activePackageFilter.price.length === 2) {
      packages = packages.filter(pkg => {
        const price = parseInt(pkg.basePrice) || 0;
        return price >= activePackageFilter.price[0] && price <= activePackageFilter.price[1];
      });
    }

    // Sort
    if (sortOrder === "price_asc") {
      packages.sort((a, b) => (parseInt(a.basePrice) || 0) - (parseInt(b.basePrice) || 0));
    } else if (sortOrder === "price_desc") {
      packages.sort((a, b) => (parseInt(b.basePrice) || 0) - (parseInt(a.basePrice) || 0));
    } else if (sortOrder === "duration_asc") {
      packages.sort((a, b) => (parseInt(a.duration) || 0) - (parseInt(b.duration) || 0));
    } else if (sortOrder === "duration_desc") {
      packages.sort((a, b) => (parseInt(b.duration) || 0) - (parseInt(a.duration) || 0));
    }

    return packages;
  }, [initialData, activePackageFilter, disabledDates, sortOrder]);

  // Function to get dates in range
  function getDatesInRange(startDate, endDate) {
    const dates = [];
    let currentDate = moment(startDate).startOf("day"); // Start of the day
    const end = moment(endDate).startOf("day"); // End of the day
    while (currentDate.isSameOrBefore(end, "day")) {
      dates.push(currentDate.format("YYYY-MM-DD")); // Store as YYYY-MM-DD
      currentDate.add(1, "day");
    }
    return dates;
  }

  useEffect(() => {
    const fetchDates = async () => {
      try {
        // Only proceed if initialData.id is defined
        if (!initialData?.id) {
          console.log('No listing ID available for fetching dates');
          return;
        }

        const filterLockedDates = await getEventsByListingId(initialData.id);

        // Handle listingLockDates safely
        const disabledDatesLocal = getFullDayLockedDates(listingLockDates, "YYYY-MM-DD");

        // Handle filterLockedDates safely
        const disabledDatesBooked = Array.isArray(filterLockedDates) ? filterLockedDates.reduce((dates, item) => {
          if (!item?.start || !item?.end) return dates;

          // Skip hourly (same-day) bookings — boat can be booked multiple times per day
          if (item.isOvernight === false) return dates;

          const datesInRange = getDatesInRange(
            moment(item.start).startOf("day"),
            moment(item.end).startOf("day")
          );
          return [...dates, ...datesInRange];
        }, []) : [];

        setDisabledDates([...disabledDatesLocal, ...disabledDatesBooked]);
      } catch (e) {
        console.error('Error fetching dates:', e);
      }
    };

    fetchDates();
  }, [listingLockDates]);

  useEffect(() => {
    const fetchLockDates = async () => {
      try {
        const lockDates = await getListingLockDatesByID(initialData.id);

        // Check if lockDates exists and is an object before using Object.entries
        if (lockDates && typeof lockDates === 'object') {
          setListingLockDatesRaw(lockDates);
          const lockDatesArray = Object.entries(lockDates).map(([id, date]) => ({
            id,
            start_date: moment(date.start_date).format("YYYY-MM-DD"),
            end_date: moment(date.end_date).format("YYYY-MM-DD"),
            time_ranges: date.time_ranges || [],
            start_time: date.start_time || null,
            end_time: date.end_time || null,
          }));
          setListingLockDates(lockDatesArray);
        } else {
          // If no lock dates, set empty array
          setListingLockDatesRaw({});
          setListingLockDates([]);
        }
      } catch (error) {
        console.error("Error fetching lock dates:", error);
        setListingLockDatesRaw({});
        setListingLockDates([]);
      }
    };
    if (initialData?.id) {
      fetchLockDates();
    }
  }, [initialData]);

  useEffect(() => {
    const fetchReviewDetails = async () => {
      try {
        const review = await getReviewsByListingId(initialData.id);
        setListingReviews(review);
        const userData = await getCurrentUserDetails();
        const meta = await getUserMetaByID(userData?.userId);
        setUserDetails(userData);
        setUserMeta(meta);
      } catch (error) {
        console.error("Error fetching listing details:", error);
      }
    };
    fetchReviewDetails();
  }, []);

  useEffect(() => {
    const fetchReviewDetails = async () => {
      try {
        const review = await getReviewsByListingId(initialData.id);
        setListingReviews(review);
        const userData = await getCurrentUserDetails();
        const meta = await getUserMetaByID(userData?.userId);
        setUserDetails(userData);
        setUserMeta(meta);
      } catch (error) {
        console.error("Error fetching listing details:", error);
      }
    };
    fetchReviewDetails();
  }, []);

  // const disabledDates = [
  //   '02/05/2024',
  //   '02/10/2024',
  // ];

  const formatDate = (date) => {
    const formattedDate = new Date(date);
    const mm = String(formattedDate.getMonth() + 1).padStart(2, "0");
    const dd = String(formattedDate.getDate()).padStart(2, "0");
    const yyyy = formattedDate.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const isDateDisabled = (date) => {
    try {
      const formattedDate = dayjs(date).format("MM/DD/YYYY");

      let disabledDatesFromCalendar = [];
      if (calendarEvents != null) {
        disabledDatesFromCalendar = calendarEvents.reduce((acc, event) => {
          // Skip hourly (same-day) bookings — boat can be booked multiple times per day
          if (event.isOvernight === false) return acc;

          const startFormatted = formatDate(event.start);
          const endFormatted = formatDate(event.end);

          // Add the start date
          if (!acc.includes(startFormatted)) {
            acc.push(startFormatted);
          }

          // Add the end date
          if (!acc.includes(endFormatted)) {
            acc.push(endFormatted);
          }

          // Add dates in between if the duration is more than one day
          if (event.start !== event.end) {
            const startDate = new Date(event.start);
            const endDate = new Date(event.end);

            const currentDate = new Date(startDate);

            while (currentDate < endDate) {
              currentDate.setDate(currentDate.getDate() + 1);
              const currentDateFormatted = formatDate(currentDate);

              if (!acc.includes(currentDateFormatted)) {
                acc.push(currentDateFormatted);
              }
            }
          }

          return acc;
        }, []);
      }
      // Extract disabledDates from listingLockDates
      const disabledDatesFromLockDates = getFullDayLockedDates(
        listingLockDatesRaw || initialData.lockDates,
        "MM/DD/YYYY"
      );
      const allDisabledDates = [
        ...disabledDatesFromCalendar,
        ...disabledDatesFromLockDates,
      ];

      return allDisabledDates.includes(formattedDate);
    } catch (e) {
      // Handle the exception if needed
    }
  };

  useEffect(() => {
    const fetchListingDetails = async () => {
      try {
        const details = await getListingByID(initialData?.id);

        setListing(details);
        setIsCaptain(details?.boatCaptain);
      } catch (error) {
        console.error("Error fetching listing details:", error);
      }
    };

    fetchListingDetails();
  }, [initialData?.id]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <>
        <section className="p-0 cs-bg-dark" style={{ overflow: "hidden" }}>
          <Row>
            <Col>
              <ListingGallery images={images} title={initialData?.listingTitle} />
            </Col>
          </Row>
        </section>

        <section className="pt-4 cs-bg-dark text-white">
          <Container>
            <Row className="mt-4 listing-container-mobile">
              <Col md={8}>
                <Row>
                  <Col>
                    <div className="d-flex align-items-center gap-3">
                      <div>
                        <h2>{initialData.listingTitle || "Boat Title"}</h2>
                        <h5>{initialData.boatType || ""}</h5>
                      </div>

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex" style={{ gap: "20px" }}>
                    <p
                      className="d-flex align-items-center"
                      style={{ gap: "5px" }}
                    >
                      <FaMapPin />
                      {listingLocation}
                    </p>
                  </Col>
                </Row>
                <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                  <Link
                    to={`/boat-owner/${initialData?.ownerId}`}
                    className="d-flex align-items-center text-white"
                    style={{ textDecoration: "none" }}
                  >
                    <UserAvatar
                      src={ownerDetails?.avatar}
                      name={`${ownerDetails?.firstName || ""} ${ownerDetails?.lastName || ""}`}
                      size={50}
                      className="me-3"
                    />
                    <div>
                      <h5 className="mb-0">{ownerDetails?.firstName} {ownerDetails?.lastName}</h5>
                      <div className="d-flex align-items-center">
                        <FaStar style={{ color: "#FFD700", marginRight: "5px" }} />
                        <span>{calculateAverageRating() ? calculateAverageRating().toFixed(1) : "New"}</span>
                        <span className="text-muted ms-1">({listingReviews?.length || 0} reviews)</span>
                      </div>
                    </div>
                  </Link>

                </div>

                <div className="d-flex flex-wrap gap-2 align-items-center">
                  {initialData?.fishingGuideDetails?.calendarRules?.instantBook && (
                    <Link
                      to={
                        auth.currentUser != null
                          ? `/listing/${initialData.id}/packages`
                          : `/auth?redirect_to=${encodeURIComponent(`/listing/${initialData.id}/packages`)}`
                      }
                    >
                      <Button className="btn mt-2 send-message-btn"
                        style={{
                          whiteSpace: 'nowrap',
                          color: '#ddb467',
                          fontFamily: 'Fjalla One, sans-serif',
                          borderColor: '#ddb467',
                          border: '1px solid #ddb467',
                          backgroundColor: 'transparent',
                          paddingLeft: '12px',
                          paddingRight: '12px'
                        }}>
                        <i className="material-icons" style={{ verticalAlign: 'middle', marginRight: '4px', color: '#ddb467' }}>flash_on</i>
                        Instant Book Package
                      </Button>
                    </Link>
                  )}
                  {/* Send Message Button - only show if not the owner viewing their own listing */}
                  {auth.currentUser?.uid !== initialData?.ownerId && (
                    <Link
                      to={
                        auth.currentUser != null
                          ? `/dashboard/inbox?userId=${initialData?.ownerId}`
                          : `/auth?redirect_to=${encodeURIComponent(`/dashboard/inbox?userId=${initialData?.ownerId}`)}`
                      }
                      className="btn mt-2 send-message-btn"
                      style={{
                        whiteSpace: 'nowrap',
                        color: '#ddb467',
                        borderColor: '#ddb467',
                        border: '1px solid #ddb467'
                      }}
                    >
                      <i className="material-icons" style={{ verticalAlign: 'middle', marginRight: '4px', color: '#ddb467' }}>chat</i>
                      Send Message
                    </Link>
                  )}
                  <Link
                    to={
                      auth.currentUser != null
                        ? "#"
                        : `/auth?redirect_to=${encodeURIComponent(`/listing/${initialData.id}`)}`
                    }
                    className="btn send-inquiry px-4 btn-block btn-primary mt-2"
                    style={{ padding: '6px 52px !important' }}
                    onClick={openCreateOfferModal}
                  >
                    <i className="material-icons">mail</i>Booking inquiry
                  </Link>
                </div>
                <hr />
                <Row>
                  <Col>
                    <p>{initialData.description || "Description here"}</p>
                  </Col>
                </Row>
                <hr />
                {(initialData?.pricing?.hourlyRate || initialData?.pricing?.hourlyOptions) && (
                  <>
                    <Row>
                      <Col>
                        <h5>Hourly Pricing</h5>
                      </Col>
                    </Row>
                    <hr />
                    {/* Display 1-hour rate if available */}
                    {initialData?.pricing?.hourlyRate && initialData?.pricing?.hourlyRate !== "0" && (
                      <Row className="mt-3">
                        <Col className="d-flex" style={{ gap: "20px" }}>
                          <p
                            className="d-flex align-items-center"
                            style={{ gap: "5px" }}
                          >
                            <span className="mx-3">1 hour</span>
                            <FaArrowRightLong />
                            <span className="mx-3">${initialData?.pricing?.hourlyRate}</span>
                          </p>
                        </Col>
                      </Row>
                    )}
                    {/* Display hourly options */}
                    {initialData?.pricing?.hourlyOptions?.map((prices, i) => (
                      <Row key={i} className="mt-3">
                        <Col className="d-flex" style={{ gap: "20px" }}>
                          <p
                            className="d-flex align-items-center"
                            style={{ gap: "5px" }}
                          >
                            <span className="mx-3">
                              {prices?.hours}{" "}
                              {prices?.hours > 1 ? "hours" : "hour"}
                            </span>
                            <FaArrowRightLong />
                            <span className="mx-3">${prices?.price}</span>
                          </p>
                        </Col>
                      </Row>
                    ))}
                    <hr />
                  </>
                )}
                {initialData?.pricing?.dailyOptions && (
                  <>
                    <Row>
                      <Col>
                        <h5>Daily Pricing {"(24 hours)"}</h5>
                      </Col>
                    </Row>
                    <hr />
                    {initialData?.pricing?.dailyOptions?.map((prices, i) => (
                      <Row key={i} className="mt-3">
                        <Col className="d-flex" style={{ gap: "20px" }}>
                          <p
                            className="d-flex align-items-center"
                            style={{ gap: "5px" }}
                          >
                            <span className="mx-3">
                              {prices?.days} {prices?.days > 1 ? "days" : "day"}
                            </span>
                            <FaArrowRightLong />
                            <span className="mx-3">
                              {Number(prices?.days) * 24} hours
                            </span>
                            <FaArrowRightLong />
                            <span className="mx-3">${prices?.price}</span>
                          </p>
                        </Col>
                      </Row>
                    ))}
                    <hr />
                  </>
                )}
                {/* Trip Packages */}
                {initialData?.fishingGuideDetails?.tripPackages && initialData?.fishingGuideDetails?.tripPackages?.length > 0 && (
                  <>
                    <Row>
                      <Col>
                        <h5>Trip Packages</h5>
                      </Col>
                    </Row>
                    <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                      <div className="d-flex flex-wrap align-items-center gap-2 mt-2 mt-md-0">
                        {/* Sort Filter */}
                        <Dropdown
                          autoClose="outside"
                          show={showPackageSortPopover}
                          onToggle={(isOpen) => {
                            setShowPackageSortPopover(isOpen);
                            if (isOpen) setTempSortOrder(sortOrder);
                          }}
                        >
                          <Dropdown.Toggle
                            variant="outline-light"
                            className="rounded-pill d-flex align-items-center no-caret-toggle px-3"
                            style={{ borderRadius: '20px', fontSize: '0.9rem' }}
                          >
                            <FaSort className="me-1" style={{ fontSize: '1rem' }} />
                            Sort by {getSortLabel(sortOrder)}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="p-3" style={{ minWidth: "200px" }}>
                            <Form>
                              {[
                                { label: "Price (Lowest)", value: "price_asc" },
                                { label: "Price (Highest)", value: "price_desc" },
                                { label: "Duration (Shortest)", value: "duration_asc" },
                                { label: "Duration (Longest)", value: "duration_desc" },
                              ].map((option) => (
                                <Form.Check
                                  type="radio"
                                  id={`sort-${option.value}`}
                                  key={option.value}
                                  label={option.label}
                                  name="sortOrder"
                                  value={option.value}
                                  checked={tempSortOrder === option.value}
                                  onChange={(e) => setTempSortOrder(e.target.value)}
                                  className="mb-2"
                                  style={{ color: 'black' }}
                                />
                              ))}
                              <Button
                                className="w-100 mt-2"
                                variant="primary"
                                size="sm"
                                onClick={() => {
                                  setSortOrder(tempSortOrder);
                                  setShowPackageSortPopover(false);
                                }}
                              >
                                Apply
                              </Button>
                            </Form>
                          </Dropdown.Menu>
                        </Dropdown>

                        <div className="vr mx-2 text-white-50 d-none d-md-block" style={{ height: '30px' }}></div>

                        {/* Date Filter */}
                        <Dropdown
                          autoClose={false}
                          show={showPackageDatePopover}
                          onToggle={(isOpen) => {
                            setShowPackageDatePopover(isOpen);
                            if (isOpen) setTempPackageFilters(prev => ({ ...prev, date: activePackageFilter.date }));
                          }}
                        >
                          <Dropdown.Toggle
                            variant="outline-light"
                            className={`rounded-pill d-flex align-items-center no-caret-toggle px-3 ${activePackageFilter.date ? "active text-primary border-primary" : ""}`}
                            style={{ borderRadius: '20px', fontSize: '0.9rem' }}
                          >
                            <CiCalendar className="me-1" style={{ fontSize: '1.2rem' }} />
                            {activePackageFilter.date ? dayjs(activePackageFilter.date).format('MMM D, YYYY') : "Date"}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="p-3" style={{ minWidth: "300px" }}>
                            <div className="px-2">
                              <DatePicker
                                label="Select Date"
                                value={tempPackageFilters.date ? dayjs(tempPackageFilters.date) : null}
                                onChange={(date) => setTempPackageFilters(prev => ({ ...prev, date: date }))}
                                minDate={dayjs()}
                                shouldDisableDate={(date) => {
                                  const formattedDate = dayjs(date).format("YYYY-MM-DD");
                                  return disabledDates.includes(formattedDate);
                                }}
                                slotProps={{ textField: { fullWidth: true } }}
                              />
                              <div className="d-flex gap-2 mt-3">
                                <Button variant="primary" size="sm" className="w-100" onClick={() => {
                                  setActivePackageFilter(prev => ({ ...prev, date: tempPackageFilters.date }));
                                  setShowPackageDatePopover(false);
                                }}>Apply</Button>
                                <Button variant="outline-secondary" size="sm" className="w-100" onClick={() => {
                                  setTempPackageFilters(prev => ({ ...prev, date: null }));
                                  setActivePackageFilter(prev => ({ ...prev, date: null }));
                                  setShowPackageDatePopover(false);
                                }}>Reset</Button>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>

                        {/* Passengers Filter */}
                        <Dropdown
                          autoClose={false}
                          show={showPackageGuestsPopover}
                          onToggle={(isOpen) => {
                            setShowPackageGuestsPopover(isOpen);
                            if (isOpen) setTempPackageFilters(prev => ({ ...prev, guests: activePackageFilter.guests }));
                          }}
                        >
                          <Dropdown.Toggle
                            variant="outline-light"
                            className={`rounded-pill d-flex align-items-center no-caret-toggle px-3 ${activePackageFilter.guests > 1 ? "active text-primary border-primary" : ""}`}
                            style={{ borderRadius: '20px', fontSize: '0.9rem' }}
                          >
                            <FaPeopleGroup className="me-1" style={{ fontSize: '1.2rem' }} />
                            {activePackageFilter.guests} Passenger{activePackageFilter.guests > 1 ? 's' : ''}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="p-3" style={{ minWidth: "200px" }}>
                            <div className="text-center">
                              <h6 className="mb-3" style={{ color: 'black' }}>Number of Passengers</h6>
                              <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  style={{ width: '36px', height: '36px', borderRadius: '50%', padding: 0, fontSize: '1.2rem', lineHeight: 1 }}
                                  onClick={() => setTempPackageFilters(prev => ({ ...prev, guests: Math.max(1, prev.guests - 1) }))}
                                  disabled={tempPackageFilters.guests <= 1}
                                >
                                  −
                                </Button>
                                <span style={{ fontSize: '1.2rem', fontWeight: 600, minWidth: '40px', color: 'black' }}>
                                  {tempPackageFilters.guests}
                                </span>
                                <Button
                                  variant="outline-secondary"
                                  size="sm"
                                  style={{ width: '36px', height: '36px', borderRadius: '50%', padding: 0, fontSize: '1.2rem', lineHeight: 1 }}
                                  onClick={() => setTempPackageFilters(prev => ({ ...prev, guests: prev.guests + 1 }))}
                                >
                                  +
                                </Button>
                              </div>
                              <div className="d-flex gap-2">
                                <Button variant="primary" size="sm" className="w-100" onClick={() => {
                                  setActivePackageFilter(prev => ({ ...prev, guests: tempPackageFilters.guests }));
                                  setShowPackageGuestsPopover(false);
                                }}>Apply</Button>
                                <Button variant="outline-secondary" size="sm" className="w-100" onClick={() => {
                                  setTempPackageFilters(prev => ({ ...prev, guests: 1 }));
                                  setActivePackageFilter(prev => ({ ...prev, guests: 1 }));
                                  setShowPackageGuestsPopover(false);
                                }}>Reset</Button>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>

                        {/* Price Filter */}
                        <Dropdown
                          autoClose="outside"
                          onToggle={(isOpen) => {
                            if (isOpen) setTempPackageFilters(prev => ({ ...prev, price: activePackageFilter.price.length ? activePackageFilter.price : [priceBounds.min, priceBounds.max] }));
                          }}
                        >
                          <Dropdown.Toggle
                            variant="outline-light"
                            className={`rounded-pill d-flex align-items-center no-caret-toggle px-3 ${isPriceFilterActive() ? "active text-primary border-primary" : ""}`}
                            style={{ borderRadius: '20px', fontSize: '0.9rem' }}
                          >
                            <FaDollarSign className="me-1" style={{ fontSize: '1rem' }} />
                            Price {isPriceFilterActive() && `($${activePackageFilter.price[0]} - $${activePackageFilter.price[1]})`}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="p-3" style={{ minWidth: "300px" }}>
                            <div className="px-2">
                              <Typography gutterBottom style={{ color: 'black', fontSize: '0.9rem' }}>
                                Price Range: ${tempPackageFilters.price[0]} - ${tempPackageFilters.price[1]}
                              </Typography>
                              <Slider
                                value={tempPackageFilters.price}
                                onChange={(e, newValue) => setTempPackageFilters(prev => ({ ...prev, price: newValue }))}
                                valueLabelDisplay="auto"
                                min={priceBounds.min}
                                max={priceBounds.max}
                                step={10}
                              />
                              <div className="d-flex gap-2 mt-3">
                                <Button variant="primary" size="sm" className="w-100" onClick={() => {
                                  setActivePackageFilter(prev => ({ ...prev, price: tempPackageFilters.price }));
                                }}>Apply</Button>
                                <Button variant="outline-secondary" size="sm" className="w-100" onClick={() => {
                                  const fullRange = [priceBounds.min, priceBounds.max];
                                  setTempPackageFilters(prev => ({ ...prev, price: fullRange }));
                                  setActivePackageFilter(prev => ({ ...prev, price: fullRange }));
                                }}>Reset</Button>
                              </div>
                            </div>
                          </Dropdown.Menu>
                        </Dropdown>

                        {/* Duration Filter */}
                        <Dropdown
                          autoClose="outside"
                          onToggle={(isOpen) => {
                            if (isOpen) setTempPackageFilters(prev => ({ ...prev, duration: activePackageFilter.duration }));
                          }}
                        >
                          <Dropdown.Toggle
                            variant="outline-light"
                            className={`rounded-pill d-flex align-items-center no-caret-toggle px-3 ${activePackageFilter.duration.length > 0 ? "active text-primary border-primary" : ""}`}
                            style={{ borderRadius: '20px', fontSize: '0.9rem' }}
                          >
                            <FaClock className="me-1" style={{ fontSize: '1rem' }} />
                            Duration {activePackageFilter.duration.length > 0 && `(${activePackageFilter.duration.length})`}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="p-3" style={{ minWidth: "200px" }}>
                            <Form>
                              {[
                                { label: "Half Day (Up to 5h)", value: "half" },
                                { label: "Full Day (6h+)", value: "full" }
                              ].map((option) => (
                                <Form.Check
                                  type="checkbox"
                                  id={`filter-duration-${option.value}`}
                                  key={option.value}
                                  label={option.label}
                                  checked={tempPackageFilters.duration.includes(option.value)}
                                  onChange={(e) => {
                                    const val = option.value;
                                    const checked = e.target.checked;
                                    setTempPackageFilters(prev => ({
                                      ...prev,
                                      duration: checked
                                        ? [...prev.duration, val]
                                        : prev.duration.filter(item => item !== val)
                                    }));
                                  }}
                                  className="mb-2"
                                  style={{ color: 'black' }}
                                />
                              ))}
                              <div className="d-flex gap-2 mt-2">
                                <Button variant="primary" size="sm" className="w-100" onClick={() => {
                                  setActivePackageFilter(prev => ({ ...prev, duration: tempPackageFilters.duration }));
                                }}>Apply</Button>
                                <Button variant="outline-secondary" size="sm" className="w-100" onClick={() => {
                                  setTempPackageFilters(prev => ({ ...prev, duration: [] }));
                                  setActivePackageFilter(prev => ({ ...prev, duration: [] }));
                                }}>Reset</Button>
                              </div>
                            </Form>
                          </Dropdown.Menu>
                        </Dropdown>

                        {(activePackageFilter.guests > 1 || activePackageFilter.date || isPriceFilterActive() || activePackageFilter.duration.length > 0) && (
                          <Button
                            variant="link"
                            className="text-white p-0"
                            onClick={() => setActivePackageFilter({ guests: 1, date: null, price: [priceBounds.min, priceBounds.max], duration: [] })}
                            style={{ textDecoration: 'none', fontSize: '0.9rem' }}
                          >
                            Clear all
                          </Button>
                        )}
                      </div>
                    </div>
                    {filteredPackages.length > 0 ? (
                      filteredPackages.map((tripPackage, index) => (
                        <PackageCard
                          key={index}
                          tripPackage={tripPackage}
                          onInstantBook={openPackageInstantBookModal}
                          onBook={handlePackageBook}
                        />
                      ))
                    ) : (
                      <div className="text-white text-center py-5 cs-bg-dark2 rounded-3 mb-4">
                        <h4 className="mb-2">No packages match your criteria.</h4>
                        <p className="text-white-50">Try adjusting your filters or sorting.</p>
                        <Button
                          variant="outline-light"
                          size="sm"
                          onClick={() => setActivePackageFilter({ guests: 1, date: null, price: [priceBounds.min, priceBounds.max], duration: [] })}
                          className="mt-2"
                        >
                          Reset Filters
                        </Button>
                      </div>
                    )}
                  </>
                )}

                {initialData?.boatCaptain !== undefined &&
                  initialData?.boatCaptain !== null && (
                    <>
                      <hr />
                      <Row>
                        <Col>
                          <Row>
                            <Col xs={2} className="d-flex justify-content-center">
                              <TbSteeringWheel style={{ fontSize: "76px" }} />
                            </Col>
                            <Col
                              xs={10}
                              className="d-flex flex-column justify-content-center"
                              style={{ color: "#ddb467" }}
                            >
                              <h5 className="text-white">
                                {initialData?.boatCaptain
                                  ? "Only Boat Owner can drive this boat"
                                  : "Both Renters & Boat Owner are allowed to drive this boat"}
                              </h5>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  )}
                <hr />

                <Row>
                  <Col>
                    <Row>
                      <Col xs={2} className="d-flex justify-content-center">
                        <FaPeopleGroup style={{ fontSize: "76px" }} />
                      </Col>
                      <Col
                        xs={10}
                        className="d-flex flex-column justify-content-center"
                      >
                        {console.log('initialData...', initialData)}
                        <h5>{initialData.boatType} • Up to {initialData.capacity} people {initialData.boatLength && ` - Length ${initialData.boatLength}ft`}</h5>
                      </Col>
                    </Row>
                  </Col>
                </Row>



                <Row>
                  <Col>
                    <h4>Features & Details</h4>
                    <h5>Boat Details</h5>
                    <Row className="px-2">
                      <Col xs={12} className="px-3">
                        <Row className="cs-bg-dark2 p-3">
                          <Col xs={2} className="text-center">
                            <CiShoppingTag
                              style={{ fontSize: "44px", textAlign: "center" }}
                            />
                          </Col>
                          <Col xs={2}>
                            <p className="mb-0 fs-10">Make</p>
                            <p className="mb-0">{initialData.make}</p>
                          </Col>
                          <Col xs={2}>
                            <p className="mb-0 fs-10">Model</p>
                            <p className="mb-0">{initialData.model}</p>
                          </Col>
                          {initialData.boatType === "Bass Boat" && (
                            <Col xs={2} className="text-center">
                              <CiCalendar
                                style={{ fontSize: "44px", textAlign: "center" }}
                              />
                            </Col>
                          )}
                          <Col
                            xs={2}
                            className="d-flex flex-column justify-content-center"
                          >
                            <p className="mb-0 fs-10">
                              {initialData.boatType === "Bass Boat"
                                ? "Year"
                                : "Motor Type"}
                            </p>
                            <h6 className="mb-0">{initialData.year}</h6>
                          </Col>
                          {initialData.boatType !== "Bass Boat" && (
                            <Col
                              xs={2}
                              className="d-flex flex-column justify-content-center"
                            >
                              <p className="mb-0 fs-10">Horse Power</p>
                              <h6 className="mb-0">{initialData.hin}</h6>
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Fishing Charter Details Section */}
                {initialData.boatType === "Fishing Charter" && initialData.fishingGuideDetails && (
                  <Row className="mt-4">
                    <Col>
                      <h4>Fishing Charter Information</h4>

                      {/* Business Information */}
                      <div
                        className="d-flex align-items-center mt-3"
                        onClick={toggleBusinessInfo}
                        style={{ cursor: "pointer", gap: "10px" }}
                      >
                        <h5 className="mb-0">Business Information</h5>
                        {isBusinessInfoOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </div>
                      {isBusinessInfoOpen && (
                        <Row className="px-2 mt-3">
                          <Col xs={12} className="px-3">
                            <Row className="cs-bg-dark2 p-3">
                              <Col xs={12} md={12}>
                                <p className="mb-0 fs-10 fw-bold">Business Name</p>
                                <p className="mb-0">{initialData.fishingGuideDetails.businessInfo?.name}</p>
                              </Col>
                              {initialData.fishingGuideDetails.businessInfo?.website && (
                                <Col xs={12} className="mt-3">
                                  <p className="mb-0 fs-10 fw-bold">Website</p>
                                  <p className="mb-0">
                                    <a href={initialData.fishingGuideDetails.businessInfo.website} target="_blank" rel="noopener noreferrer">
                                      {initialData.fishingGuideDetails.businessInfo.website}
                                    </a>
                                  </p>
                                </Col>
                              )}
                              <Col xs={12} className="mt-3">
                                <p className="mb-0 fs-10 fw-bold">Location</p>
                                <p className="mb-0">
                                  {initialData.fishingGuideDetails.businessInfo?.city}, {initialData.fishingGuideDetails.businessInfo?.state}, {initialData.fishingGuideDetails.businessInfo?.country}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}

                      {/* Fishing Experience */}
                      {initialData.fishingGuideDetails.fishingExperience && (
                        <>
                          <h5 className="mt-3">Fishing Experience</h5>
                          <Row className="px-2">
                            <Col xs={12} className="px-3">
                              <Row className="cs-bg-dark2 p-3">
                                {(
                                  (initialData.fishingGuideDetails.fishingExperience.styles && initialData.fishingGuideDetails.fishingExperience.styles.length > 0) ||
                                  (initialData.fishingGuideDetails.fishingExperience.techniques && initialData.fishingGuideDetails.fishingExperience.techniques.length > 0)
                                ) && (
                                    <Col xs={12} md={6}>
                                      <p className="mb-0 fs-10 fw-bold">Fishing Styles</p>
                                      <ul className="mb-0 ps-3">
                                        {initialData.fishingGuideDetails.fishingExperience.styles && initialData.fishingGuideDetails.fishingExperience.styles.map((style, index) => (
                                          <li key={`style-${index}`}>{style}</li>
                                        ))}
                                        {initialData.fishingGuideDetails.fishingExperience.techniques && initialData.fishingGuideDetails.fishingExperience.techniques.map((technique, index) => (
                                          <li key={`tech-${index}`}>{technique}</li>
                                        ))}
                                      </ul>
                                    </Col>
                                  )}

                                {initialData.fishingGuideDetails.fishingExperience.species && initialData.fishingGuideDetails.fishingExperience.species.length > 0 && (
                                  <Col xs={12} md={6}>
                                    <p className="mb-0 fs-10 fw-bold">Target Species</p>
                                    <ul className="mb-0 ps-3">
                                      {initialData.fishingGuideDetails.fishingExperience.species.map((species, index) => (
                                        <li key={index}>{species}</li>
                                      ))}
                                    </ul>
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}

                      {/* What's Included */}
                      {initialData.fishingGuideDetails.whatsIncluded && (
                        <>
                          <h5 className="mt-3">What's Included</h5>
                          <Row className="px-2">
                            <Col xs={12} className="px-3">
                              <Row className="cs-bg-dark2 p-3">
                                {initialData.fishingGuideDetails.whatsIncluded.included && initialData.fishingGuideDetails.whatsIncluded.included.length > 0 && (
                                  <Col xs={12} md={6}>
                                    <p className="mb-0 fs-10 fw-bold">Included</p>
                                    <ul className="mb-0 ps-3">
                                      {initialData.fishingGuideDetails.whatsIncluded.included.map((item, index) => (
                                        <li key={index}>{item}</li>
                                      ))}
                                    </ul>
                                  </Col>
                                )}

                                {initialData.fishingGuideDetails.whatsIncluded.notIncluded && (
                                  <Col xs={12} md={6}>
                                    <p className="mb-0 fs-10 fw-bold">Not Included</p>
                                    <ul className="mb-0 ps-3">
                                      {initialData.fishingGuideDetails.whatsIncluded.notIncluded.excluded && initialData.fishingGuideDetails.whatsIncluded.notIncluded.excluded.map((item, index) => (
                                        <li key={`excluded-${index}`}>{item}</li>
                                      ))}
                                      {initialData.fishingGuideDetails.whatsIncluded.notIncluded.fuelSurcharge && (
                                        <li>Fuel Surcharge: {initialData.fishingGuideDetails.whatsIncluded.notIncluded.fuelSurcharge}</li>
                                      )}
                                      {initialData.fishingGuideDetails.whatsIncluded.notIncluded.cleaningFee && (
                                        <li>Cleaning Fee: {initialData.fishingGuideDetails.whatsIncluded.notIncluded.cleaningFee}</li>
                                      )}
                                      {initialData.fishingGuideDetails.whatsIncluded.notIncluded.gratuityExpected && (
                                        <li>Optional Gratuity recommended: {initialData.fishingGuideDetails.whatsIncluded.notIncluded.recommendedGratuity ? `${initialData.fishingGuideDetails.whatsIncluded.notIncluded.recommendedGratuity}` : 'Yes'}</li>
                                      )}
                                      {initialData.fishingGuideDetails.whatsIncluded.notIncluded.customItems?.map((item, index) => (
                                        <li key={`custom-${index}`}>{item.label}: {item.value}</li>
                                      ))}
                                    </ul>
                                    {initialData.fishingGuideDetails.whatsIncluded.notIncluded.additionalInfo && (
                                      <div className="mt-2">
                                        <p className="mb-0 fs-10 fw-bold">Additional Information</p>
                                        <p className="mb-0">{initialData.fishingGuideDetails.whatsIncluded.notIncluded.additionalInfo}</p>
                                      </div>
                                    )}
                                  </Col>
                                )}
                              </Row>
                            </Col>
                          </Row>
                        </>
                      )}


                    </Col>
                  </Row>
                )}
                {(initialData.boatType === "Bass Boat" || initialData.boatType === "Fishing Charter") && (
                  <Row className="mt-4">
                    <Col xs="6">
                      <ul>
                        {firstHalf.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </Col>
                    <Col xs="6">
                      <ul>
                        {secondHalf.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                    </Col>
                  </Row>
                )}

                {initialData.boatType === "Bass Boat" && (
                  <>
                    <hr />
                    <Row>
                      <Col>
                        <h4>Additional Boat Info</h4>
                        <h5 className="mt-3">Motor Details</h5>
                        <Row className="px-2">
                          <Col xs={12} className="px-3">
                            <Row className="cs-bg-dark2 p-3">
                              <Col xs={2} className="text-center">
                                <CiShoppingTag
                                  style={{
                                    fontSize: "44px",
                                    textAlign: "center",
                                  }}
                                />
                              </Col>
                              <Col xs={3}>
                                <h6 className="mb-0">Make</h6>
                                <p className="mb-0">{initialData.motorMake}</p>
                              </Col>
                              <Col xs={3}>
                                <h6 className="mb-0">Model</h6>
                                <p className="mb-0">{initialData.motorModel}</p>
                              </Col>
                              <Col xs={2} className="text-center">
                                <RxWidth
                                  style={{
                                    fontSize: "44px",
                                    textAlign: "center",
                                  }}
                                />
                              </Col>
                              <Col
                                xs={2}
                                className="d-flex flex-column justify-content-center"
                              >
                                <p className="mb-0 fs-10">Year</p>
                                <h6 className="mb-0">{initialData.motorYear}</h6>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <h5 className="mt-3">Trailer Details</h5>
                        <Row className="px-2">
                          <Col xs={12} md={8} className="px-3">
                            <Row className="cs-bg-dark2 p-3">
                              <Col xs={2} className="text-center">
                                <CiShoppingTag
                                  style={{
                                    fontSize: "44px",
                                    textAlign: "center",
                                  }}
                                />
                              </Col>
                              <Col xs={5}>
                                <h6 className="mb-0">Make</h6>
                                <p className="mb-0">{initialData.trailerMake}</p>
                              </Col>
                              <Col xs={5}>
                                <h6 className="mb-0">Year</h6>
                                <p className="mb-0">{initialData.trailerYear}</p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <h5 className="mt-3">Trolling Motor Details</h5>
                        <Row className="px-2">
                          <Col xs={12} md={10} className="px-3">
                            <Row className="cs-bg-dark2 p-3">
                              <Col xs={2} className="text-center">
                                <CiShoppingTag
                                  style={{
                                    fontSize: "44px",
                                    textAlign: "center",
                                  }}
                                />
                              </Col>
                              <Col xs={3}>
                                <h6 className="mb-0">Make</h6>
                                <p className="mb-0">
                                  {initialData.trollingMotorMake}
                                </p>
                              </Col>
                              <Col xs={4}>
                                <h6 className="mb-0">Model</h6>
                                <p className="mb-0">
                                  {initialData.trollingMotorModel}
                                </p>
                              </Col>
                              <Col
                                xs={3}
                                className="d-flex flex-column justify-content-center"
                              >
                                <p className="mb-0 fs-10">Year</p>
                                <h6 className="mb-0">
                                  {initialData.trailerYear}
                                </h6>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <h5 className="mt-3">Shallow Water Anchors</h5>
                        <Row className="px-2">
                          <Col xs={12} md={7} className="px-3">
                            <Row className="cs-bg-dark2 p-3">
                              <Col xs={2} className="text-center">
                                <CiShoppingTag
                                  style={{
                                    fontSize: "44px",
                                    textAlign: "center",
                                  }}
                                />
                              </Col>
                              <Col xs={3}>
                                <h6 className="mb-0">Number</h6>
                                <p className="mb-0">
                                  {typeof initialData.shallowWaterAnchors === 'string'
                                    ? (initialData.shallowWaterAnchors.toLowerCase() === 'yes' ? '1' : initialData.shallowWaterAnchors.toLowerCase() === 'no' ? '2' : initialData.shallowWaterAnchors)
                                    : (initialData.shallowWaterAnchors || "")}
                                </p>
                              </Col>
                              <Col xs={6}>
                                <h6 className="mb-0">Brand & Model</h6>
                                <p className="mb-0">
                                  {initialData.shallowWaterAnchorBrandModel}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <h5 className="mt-3">FFS - Forward Facing Sonar</h5>
                        <Row className="px-2">
                          <Col xs={12} className="px-3">
                            <Row className="cs-bg-dark2 p-3">
                              <Col xs={2} className="text-center">
                                <CiShoppingTag
                                  style={{
                                    fontSize: "44px",
                                    textAlign: "center",
                                  }}
                                />
                              </Col>
                              <Col xs={4}>
                                <h6 className="mb-0">Make</h6>
                                <p className="mb-0">{initialData.ffsMake}</p>
                              </Col>
                              <Col xs={3}>
                                <h6 className="mb-0">Model</h6>
                                <p className="mb-0">{initialData.ffsModel}</p>
                              </Col>
                              <Col xs={3}>
                                <h6 className="mb-0">Year</h6>
                                <p className="mb-0">{initialData.ffsYear}</p>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <h5 className="mt-3">Graph (Make, Model & Year)</h5>
                        <Row className="px-2">
                          <Col xs={12} className="px-3">
                            <Row
                              className="cs-bg-dark2 p-3"
                              style={{ gap: "20px" }}
                            >
                              <Row>
                                <Col xs={6}>
                                  <h6 className="mb-0">
                                    Graph 1 Make - Model - Year
                                  </h6>
                                  <p className="mb-0">
                                    {initialData.graph1Make} -{" "}
                                    {initialData.graph1Model} -{" "}
                                    {initialData.graph1Year}
                                  </p>
                                </Col>
                                <Col xs={6}>
                                  <h6 className="mb-0">
                                    Graph 2 Make - Model - Year
                                  </h6>
                                  <p className="mb-0">
                                    {initialData.graph2Make} -{" "}
                                    {initialData.graph2Model} -{" "}
                                    {initialData.graph2Year}
                                  </p>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={6}>
                                  <h6 className="mb-0">
                                    Graph 3 Make - Model - Year
                                  </h6>
                                  <p className="mb-0">
                                    {initialData.graph3Make} -{" "}
                                    {initialData.graph3Model} -{" "}
                                    {initialData.graph3Year}
                                  </p>
                                </Col>
                                <Col xs={6}>
                                  <h6 className="mb-0">
                                    Graph 4 Make - Model - Year
                                  </h6>
                                  <p className="mb-0">
                                    {initialData.graph4Make} -{" "}
                                    {initialData.graph4Model} -{" "}
                                    {initialData.graph4Year}
                                  </p>
                                </Col>
                              </Row>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}

                {/* Cancellation Policy Section */}
                {Boolean(initialData.fishingGuideDetails?.policies?.cancellation) && (
                    <>
                      <hr />
                      <Row>
                        <Col>
                          <h4>Cancellation Policy</h4>
                          <div
                            className="p-3 mt-2"
                            style={{
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem"
                            }}
                          >
                            {initialData.fishingGuideDetails.policies.cancellation === "Relaxed" && (
                              <>
                                <h5 style={{ color: "#28a745" }}>Relaxed Policy</h5>
                                <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>100%</strong> of the rental price refunded if cancelled more than <strong>24 hours</strong> prior to commencement of the rental.
                                </p>
                                <p className="mb-0" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>50%</strong> of the rental price refunded if cancelled within <strong>24 hours</strong> of commencement of the rental.
                                </p>
                              </>
                            )}
                            {initialData.fishingGuideDetails.policies.cancellation === "Regulated" && (
                              <>
                                <h5 style={{ color: "#ffc107" }}>Regulated Policy</h5>
                                <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>100%</strong> of the rental price refunded if cancelled more than <strong>7 days</strong> prior to commencement of the rental.
                                </p>
                                <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>75%</strong> of the rental price refunded if cancelled less than <strong>7 days</strong> but more than <strong>48 hours</strong> prior to commencement of the rental.
                                </p>
                                <p className="mb-0" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>50%</strong> of the rental price refunded if cancelled less than <strong>48 hours</strong> but more than <strong>24 hours</strong> prior to commencement of the rental.
                                </p>
                              </>
                            )}
                            {initialData.fishingGuideDetails.policies.cancellation === "Restricted" && (
                              <>
                                <h5 style={{ color: "#dc3545" }}>Restricted Policy</h5>
                                <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>75%</strong> of the rental price refunded if cancelled more than <strong>7 days</strong> prior to commencement of the rental.
                                </p>
                                <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>50%</strong> of the rental price refunded if cancelled less than <strong>7 days</strong> but more than <strong>48 hours</strong> prior to commencement of the rental.
                                </p>
                                <p className="mb-0" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>25%</strong> of the rental price refunded if cancelled less than <strong>48 hours</strong> but more than <strong>24 hours</strong> prior to commencement of the rental.
                                </p>
                              </>
                            )}
                            {initialData.fishingGuideDetails.policies.cancellation === "Free" && (
                              <>
                                <h5 style={{ color: "#17a2b8", fontWeight: "bold" }}>Free Cancellation</h5>
                                <p className="mb-0" style={{ fontSize: "14px", color: "#000000" }}>
                                  <strong>100%</strong> refund for all cancellations. No charges will be applied for any cancellation.
                                </p>
                              </>
                            )}
                            <p className="mt-2 mb-0" style={{ fontSize: "12px", fontStyle: "italic", color: "#000000" }}>
                              Note: Transaction fees and applicable taxes remitted to taxing authorities prior to cancellation will not be automatically refunded.
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </>
                  )}

                {/* Default Policy for boats without a selected policy */}
                {!(initialData.fishingGuideDetails?.policies?.cancellation) && (
                  <>
                    <hr />
                    <Row>
                      <Col>
                        <h4>Cancellation Policy</h4>
                        <div
                          className="p-3 mt-2"
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #dee2e6",
                            borderRadius: "0.375rem"
                          }}
                        >
                          <h5 style={{ color: "#6c757d" }}>Standard BBR Policy</h5>
                          <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                            <strong>Full refund</strong> if cancelled at least <strong>2 weeks</strong> prior to the reservation.
                          </p>
                          <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                            Cancellations made within <strong>2 weeks</strong> and up to <strong>48 hours</strong> of the booking will forfeit the <strong>20% deposit</strong>.
                          </p>
                          <p className="mb-1" style={{ fontSize: "14px", color: "#000000" }}>
                            Cancellations made within <strong>48 hours</strong> prior to the reservation will be charged the full amount unless the renter re-schedules to a date within 90 days of the original reservation.
                          </p>
                          <p className="mb-0" style={{ fontSize: "14px", color: "#000000" }}>
                            <strong>No-shows</strong> for any reservation will be charged the full amount.
                          </p>
                          <p className="mt-2 mb-0" style={{ fontSize: "12px", fontStyle: "italic", color: "#000000" }}>
                            Note: Transaction fees and applicable taxes remitted to taxing authorities prior to cancellation will not be automatically refunded.
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}

                {/* Departure Location & Meeting Instructions - moved below Cancellation Policy */}
                {initialData?.fishingGuideDetails && (
                  <>
                    <hr />
                    <Row className="mb-4">
                      <Col xs={12}>
                        <h4>Departure Location & Area</h4>
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col xs={12}>
                        <h5>Departure Point</h5>
                        <p><strong>Boat Location:</strong> {initialData?.storageAddress ? listingLocation : "Location not specified"}</p>

                        {initialData?.fishingGuideDetails?.businessInfo?.marinaName && (
                          <p><strong>Marina / Dock / Ramp Name:</strong> {initialData.fishingGuideDetails.businessInfo.marinaName}</p>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-4">
                      <Col xs={12}>
                        <h5>Meeting Instructions</h5>
                        {initialData?.fishingGuideDetails?.businessInfo?.meetingInstructions && (
                          <p><strong>Where to meet:</strong> {initialData.fishingGuideDetails.businessInfo.meetingInstructions}</p>
                        )}

                        {initialData?.fishingGuideDetails?.businessInfo?.parkingInstructions && (
                          <p><strong>Parking / Gate / Check-in Instructions:</strong> {initialData.fishingGuideDetails.businessInfo.parkingInstructions}</p>
                        )}
                      </Col>
                    </Row>
                  </>
                )}

                <hr />
                {/* hidden calendar for now TODO  */}
                <Row className="listingCal d-none">
                  <Col>
                    <h4>Check Availability</h4>
                    <TwoMonthCalendar
                      events={loading ? "" : calendarEvents}
                      onDateSelect={handleCalendarDateSelect}
                    />
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <h4>Reviews</h4>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        {listingReviews &&
                          listingReviews.map((review, index) => (
                            <React.Fragment key={index}>
                              <Row
                                key={index}
                                className="mb-3 cs-bxg-dark2 px-2 py-4"
                              >
                                <Col xs={11}>
                                  <Row className="mb-3">
                                    <div className="d-flex align-items-center mb-3">
                                      <h5 className="mb-0 me-3">
                                        {`${review.firstname} ${review.lastname}`}{" "}
                                        {review.timestamp && (
                                          <small className="text-muted ms-2" style={{ fontSize: '0.8em' }}>
                                            {new Date(
                                              review.timestamp
                                            ).toLocaleDateString("en-GB", {
                                              day: "numeric",
                                              month: "long",
                                              year: "numeric",
                                            })}
                                          </small>
                                        )}
                                      </h5>
                                      {userDetails?.role === "Admin" && (
                                        <button
                                          className="btn ms-3 d-flex align-items-center delete-review-btn"
                                          onClick={() =>
                                            handleDeleteReview(review.id)
                                          }
                                          title="Delete Review"
                                        >
                                          <FaTrash className="me-2" /> Delete Review
                                        </button>
                                      )}
                                    </div>
                                    {[
                                      "Listing Accuracy",
                                      "Itinerary & Experience",
                                      "Vessel & Equipment",
                                      "Departure & Return",
                                      "Value",
                                      "Communication",
                                    ].map((category) =>
                                      review[category] !== undefined && (
                                        <Col xs={3} className="mb-3" key={category}>
                                          <div>
                                            <p className="mb-1 testimonialMessage">
                                              {category}
                                            </p>
                                            <div className="d-flex align-items-center">
                                              {[...Array(review[category])].map(
                                                (_, i) => (
                                                  <FaStar
                                                    style={{ color: "gold" }}
                                                    key={i}
                                                  />
                                                )
                                              )}
                                            </div>
                                          </div>
                                        </Col>
                                      )
                                    )}
                                  </Row>
                                  <Row>
                                    <Col>
                                      <p className="testimonialMessage">
                                        {review.review}
                                      </p>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </React.Fragment>
                          ))}
                      </Col>
                    </Row>
                    <hr />
                    {auth.currentUser?.uid !== initialData?.ownerId && (
                      <Row className="mt-3 mb-4">
                        <Col>
                          <div>
                            <h4>Add A Review</h4>
                          </div>
                          {currentUser ? (
                            <Form onSubmit={handleReviewSubmit}>
                              <Row>
                                <Col xs={12}>
                                  <p className="mb-3 text-white">Reviewing as: <strong>{userDetails?.firstName} {userDetails?.lastName}</strong></p>
                                </Col>
                              </Row>
                              <FormGroup>
                                <Form.Label>Review</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  name="review"
                                  value={ReviewformData.review}
                                  onChange={handleReviewInputChange}
                                />
                              </FormGroup>
                              {/* Star Ratings */}
                              <Row>
                                {[
                                  "Listing Accuracy",
                                  "Itinerary & Experience",
                                  "Vessel & Equipment",
                                  "Departure & Return",
                                  "Value",
                                  "Communication",
                                ].map((category) => (
                                  <Col xs={6} md={4} key={category}>
                                    <FormGroup className="mt-3">
                                      <Form.Label className="mb-0">
                                        {category}
                                      </Form.Label>
                                      {/* Integrate the StarRating component here */}
                                      <StarRating
                                        rating={ReviewformData[category]}
                                        onRatingChange={(rating) =>
                                          handleRatingChange(category, rating)
                                        }
                                      />
                                    </FormGroup>
                                  </Col>
                                ))}
                              </Row>

                              <Button type="submit" className="mt-4">
                                Submit Review
                              </Button>
                            </Form>
                          ) : (
                            <div className="cs-bxg-dark2 p-4 mt-3 text-center rounded">
                              <p className="mb-0 text-white">
                                Please{" "}
                                <Link
                                  to={`/auth?redirect_to=${encodeURIComponent(
                                    `/listing/${initialData.id}`
                                  )}`}
                                  style={{ color: "#ddb467", fontWeight: "bold", textDecoration: "none" }}
                                >
                                  log in
                                </Link>{" "}
                                to leave a review.
                              </p>
                            </div>
                          )}
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
              {/* <Col md={4} xs={12} className="px-4">
              <Row className="card p-3 inqueryBox">
                <Col className="d-flex flex-column">
                  <h3>Interested?</h3>
                  <Link
                    to={
                      auth.currentUser != null
                        ? "#"
                        : `/auth?redirect_to=${listingId}`
                    }
                    className="btn send-inquiry btn-block btn-primary mt-2"
                    onClick={openCreateOfferModal}
                  >
                    <i className="material-icons">mail</i>Book Now
                  </Link>
                  {error && (
                    <Alert className="mt-3" severity="error">
                      {errorMessage}
                    </Alert>
                  )}
                  {initialData &&
                    // initialData?.boatType !== "Bass Boat" &&
                    initialData?.pricing &&
                    initialData?.pricing?.hourlyRate &&
                    initialData?.pricing?.hourlyRate !== "0" ? (
                    <Row className="mt-4">
                      <Col
                        xs={6}
                        className="d-flex flex-row align-items-center gap-2"
                      >
                        <h5>Starting From:</h5>
                      </Col>
                      <Col
                        xs={6}
                        className="d-flex flex-row align-items-center gap-2"
                      >
                        <h5>${initialData?.pricing?.hourlyRate}/hour</h5>
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}

                  <Row className="mt-4">
                    <Col
                      xs={6}
                      className="d-flex flex-row align-items-center gap-2"
                    >
                      <h5>Owner</h5>
                    </Col>
                    <Col xs={6}>
                      <Link
                        to={`/boat-owner/${initialData?.ownerId}`}
                        className="d-flex flex-row align-items-center gap-2 text-white"
                        style={{ textDecoration: "none" }}
                      >
                      <UserAvatar
                        src={ownerDetails?.avatar}
                        name={`${ownerDetails?.firstName || ""} ${ownerDetails?.lastName || ""}`}
                        size={50}
                        className=""
                        style={{ cursor: "pointer" }}
                      />
                      {lightboxIsOpen && (
                        <Lightbox
                          image={ownerDetails.avatar}
                          onClose={() => setLightboxIsOpen(false)}
                        />
                      )}
                      <h5>
                        {ownerDetails.firstName} {ownerDetails.lastName}
                      </h5>
                      </Link>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col> */}
            </Row>
          </Container>
        </section >

        <Dialog
          fullScreen={fullScreen}
          aria-labelledby="responsive-dialog-title"
          onClose={closeCreateOfferModal}
          fullWidth
          open={isCreateOfferModalOpen}
        >
          <div className="d-flex justify-content-end">
            <IoClose
              className="close-icon"
              style={{
                color: "red",
                marginRight: "1rem",
                marginTop: "1rem",
                width: "max-content",
                fontSize: "1.5rem",
                textDecoration: "none",
              }}
              onClick={closeCreateOfferModal}
            />
          </div>
          {step === 1 && (
            <DialogTitle id="responsive-dialog-title">
              Send a Booking Inquiry
            </DialogTitle>
          )}
          {step === 2 && (
            <DialogTitle id="responsive-dialog-title">Duration</DialogTitle>
          )}
          {step === 3 && (
            <DialogTitle id="responsive-dialog-title">Preferred Date</DialogTitle>
          )}
          {step === 4 && (
            <DialogTitle id="responsive-dialog-title">Departure Time</DialogTitle>
          )}
          {/* {step === 5 && initialData?.boatType === "Fishing Charter" && (
          <DialogTitle id="responsive-dialog-title">Group Size</DialogTitle>
        )} */}

          {initialData?.boatType?.toLowerCase() === "kayak".toLowerCase() ||
            initialData?.boatType?.toLowerCase() === "Jetski".toLowerCase() ? (
            <>
              {step === 5 && (
                <DialogTitle id="responsive-dialog-title">
                  Available {initialData?.boatType}
                </DialogTitle>
              )}

              {/* {step === 6 && (
              <DialogTitle id="responsive-dialog-title">Group Size</DialogTitle>
            )} */}
              {step === 7 && (
                <DialogTitle id="responsive-dialog-title">
                  Anything Else?
                </DialogTitle>
              )}
              {step === 8 && (
                <DialogTitle id="responsive-dialog-title">
                  Your Contact Details
                </DialogTitle>
              )}
              {step === 9 && (
                <DialogTitle id="responsive-dialog-title">Password</DialogTitle>
              )}
              {step === 10 && (
                <DialogTitle id="responsive-dialog-title">
                  Inquiry Sent!
                </DialogTitle>
              )}
            </>
          ) : (
            <>
              {step === 5 && (
                <DialogTitle id="responsive-dialog-title">Group Size</DialogTitle>
              )}
              {step === 6 && (
                <DialogTitle id="responsive-dialog-title">
                  Anything Else?
                </DialogTitle>
              )}
              {step === 7 && (
                <DialogTitle id="responsive-dialog-title">
                  Your Contact Details
                </DialogTitle>
              )}
              {step === 8 && (
                <DialogTitle id="responsive-dialog-title">Password</DialogTitle>
              )}
              {step === 9 && (
                <DialogTitle id="responsive-dialog-title">
                  Inquiry Sent!
                </DialogTitle>
              )}
            </>
          )}

          <DialogContent>
            {auth.currentUser != null ? (
              <ProgressBar now={(step / 7) * 100} className="mb-4" />
            ) : (
              <ProgressBar now={(step / 9) * 100} className="mb-4" />
            )}

            {/* Instant Booking Information Banner */}
            {/* {initialData?.fishingGuideDetails?.calendarRules?.instantBook && (
            <Alert severity="success" className="mb-3 d-flex align-items-center">
              <i className="material-icons me-2">flash_on</i>
              <div>
                <strong>Instant Book Available!</strong>
                <br />
                Book instantly and skip the wait. Requires at least{" "}
                {initialData?.fishingGuideDetails?.calendarRules?.leadTime || "advance notice"} before your trip.
              </div>
            </Alert>
          )} */}

            {step === 1 && (
              <>
                <Row className="d-flex justify-content-center align-items-center gap-4">
                  <img
                    className="img-responsive"
                    src="/inquiry.png"
                    style={{ width: "120px", textAlign: "center" }}
                  />
                  <p>
                    We’ll ask you a few questions so the listing owner can send
                    you a custom price, itinerary and more information. No
                    commitment or credit card needed.
                  </p>
                </Row>
              </>
            )}
            {step === 2 && (
              <>
                <Row className="d-flex justify-content-center align-items-center gap-4">
                  <h6 style={{ textAlign: "center", display: "none" }}>
                    How long do you want your trip or rental to be?
                  </h6>
                  <h5 style={{ textAlign: "center", display: "none" }}>Return on same day?</h5>

                  {inquiryData?.isPackageBooking && (
                    <div className="alert alert-info text-center mx-auto" style={{ width: "90%", marginBottom: "15px" }}>
                      Your duration is locked to {inquiryData.sameDayHours} hours for the selected package ({inquiryData.packageId}).
                    </div>
                  )}

                  {initialData &&
                    initialData?.pricing &&
                    initialData?.pricing?.hourlyOptions &&
                    initialData?.pricing?.hourlyOptions?.length > 0 && (
                      <>
                        <h4 style={{ textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>
                          Hourly Packages
                        </h4>
                        <div className="d-flex justify-content-center align-items-center gap-3">
                          <Form.Select
                            name="sameDayHours"
                            id="sameDayHours"
                            value={inquiryData.sameDayHours}
                            onChange={(e) => {
                              // setInquiryData((prevData) => ({
                              //   ...prevData,
                              //   overnight: 0,
                              //   sameDayHours:
                              //     // inquiryData.overnight === 0
                              //     parseInt(e.target.value, 10),
                              //   // : 0,
                              // }));
                              handleInquiryChange(e, "sameDayHours");
                            }}
                            className="form-select"
                            style={{ width: "90%" }}
                            disabled={inquiryData?.isPackageBooking}
                            required
                          >
                            <option value="" default>
                              Select An Option
                            </option>
                            {initialData?.pricing?.hourlyOptions?.map(
                              (option) => (
                                <option key={option.hours} value={option.hours}>
                                  {option.hours} Hours (${option.price})
                                </option>
                              )
                            )}
                          </Form.Select>
                        </div>
                      </>
                    )}
                  <Row>
                    <Col xs={12} className="text-center">
                      {((initialData?.pricing?.hourlyRate &&
                        parseFloat(initialData?.pricing?.hourlyRate) > 0) ||
                        initialData?.boatType === "Bass Boat") && (
                          <>
                            <Row>
                              <Col>
                                {/* Estimated price moved to bottom */}

                                {/* Show additional passenger charges if applicable */}
                                {initialData?.boatType === "Fishing Charter" &&
                                  inquiryData?.additionalPassengers > 0 && (
                                    <div className="additional-charges mt-2">
                                      <p className="mb-1">Base price includes up to {initialData?.pricing?.maxPassengers} passengers</p>
                                      <p className="mb-1">Additional passengers: {inquiryData.additionalPassengers}</p>
                                      <p className="mb-1">Additional charge: ${inquiryData.priceIncrease?.toFixed(2)}
                                        ({initialData?.pricing?.additionalPassengerPercentage}% per passenger)</p>
                                    </div>
                                  )}
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <h4 style={{ textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>
                                  Rent By Hours
                                </h4>
                              </Col>
                            </Row>
                            <Row>
                              <Col className="d-flex" style={{ gap: "5px" }}>
                                <Button
                                  onClick={() => handleRemove("sameDayHours")}
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ width: "10px" }}
                                  disabled={inquiryData?.isPackageBooking}
                                >
                                  <i className="material-icons add-remove">
                                    remove_circle
                                  </i>
                                </Button>
                                <Form.Control
                                  type="number"
                                  name="sameDayHours"
                                  className="form-control"
                                  value={inquiryData.sameDayHours}
                                  onChange={(e) =>
                                    handleInquiryChange(e, "sameDayHours")
                                  }
                                  disabled={inquiryData?.isPackageBooking}
                                  required
                                />
                                <Button
                                  onClick={() => handleAdd("sameDayHours")}
                                  className="d-flex justify-content-center align-items-center"
                                  style={{ width: "10px" }}
                                  disabled={inquiryData?.isPackageBooking}
                                >
                                  <i className="material-icons add-remove">
                                    add_circle
                                  </i>
                                </Button>
                              </Col>
                            </Row>
                          </>
                        )}
                    </Col>
                  </Row>
                  {initialData &&
                    (initialData?.pricing?.dailyOptions?.length > 0) && (
                      <>
                        <h4 style={{ textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>
                          Overnight
                        </h4>
                        <div className="d-flex justify-content-center align-items-center gap-3">
                          <Form.Select
                            name="overnight"
                            value={inquiryData.overnight}
                            onChange={(e) => handleInquiryChange(e, "overnight")}
                            className="form-select"
                            style={{ width: "90%" }}
                            disabled={inquiryData?.isPackageBooking}
                            required
                          >
                            <option value="" default>
                              Select An Option
                            </option>
                            {initialData.pricing &&
                              initialData.pricing.dailyOptions &&
                              initialData.pricing.dailyOptions.length > 0
                              ? initialData.pricing.dailyOptions.map((option) => (
                                <option key={option.days} value={option.days}>
                                  {`${option.days} Days (${option.days * 24
                                    } hours)`}
                                </option>
                              ))
                              : null}
                          </Form.Select>
                        </div>
                      </>
                    )}
                </Row>

                {(initialData?.boatType !== "Fishing Charter" || initialData?.deliveryAndPickup) && (
                  <Row className="mt-4">
                    {/* <h4 style={{ textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>Additionals</h4> */}
                    <FormGroup className="d-flex justify-content-center align-items-center">
                      {initialData?.boatType !== "Fishing Charter" && (
                        <>
                          {/* <div className="d-flex align-items-center mt-1 additional-box">
                          <FormControlLabel
                            style={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                checked={trailerCheckbox}
                                onChange={handleTrailerCheckbox}
                              />
                            }
                          />
                          <div>
                            <p style={{ fontWeight: "500", lineHeight: "28px" }}>
                              Price Quote for Trailer Package.
                            </p>
                          </div>
                        </div> */}
                          {/* Only show optional captain option when boat can be driven by renter (boatCaptain is false) and has optional captain service */}
                          {initialData?.boatCaptain === false && (
                            <div className="d-flex mt-1 additional-box">
                              <FormControlLabel
                                style={{ alignItems: "flex-start" }}
                                control={
                                  <Checkbox
                                    checked={isCaptain}
                                    onChange={handleCaptainCheckbox}
                                  />
                                }
                              />
                              <div>
                                <p style={{ fontWeight: "500", lineHeight: "28px" }}>
                                  Price Quote to Optional Captain
                                </p>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      {initialData?.deliveryAndPickup && (
                        <div className="d-flex align-items-center mt-1 additional-box">
                          <FormControlLabel
                            style={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                checked={DeliveryService}
                                onChange={(e) =>
                                  setDeliveryService(e.target.checked)
                                }
                              />
                            }
                          />
                          <div>
                            <p style={{ fontWeight: "500", lineHeight: "28px" }}>
                              Price Quote for Delivery & Pickup Services
                            </p>
                          </div>
                        </div>
                      )}
                    </FormGroup>
                  </Row>
                )}
              </>
            )}

            {step === 3 && (
              <>
                <Row className="d-flex justify-content-center align-items-center gap-4">
                  {/* <h6 style={{ textAlign: "center" }}>
                  Provide the preferred date for your trip in the first field
                  below.
                </h6> */}
                  <div className="d-flex justify-content-center align-items-center gap-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        minDate={dayjs().startOf("day")}
                        value={dayjs(inquiryData.prefferedDate)}
                        onChange={(date) =>
                          handleDateChange(date, "prefferedDate")
                        }
                        label="Preferred Date *"
                        required
                        shouldDisableDate={(date) => {
                          const formattedDate = dayjs(date).format("YYYY-MM-DD");
                          const normalizedDisabledDates = disabledDates.map((d) =>
                            dayjs(d).format("YYYY-MM-DD")
                          );

                          return normalizedDisabledDates.includes(formattedDate);
                        }}
                        disablePast
                      />
                    </LocalizationProvider>
                    <div className="d-flex flex-column gap-0">
                      <p className="p-tag-inquiry">
                        Duration:{" "}
                        <span style={{ fontWeight: "bold", display: "block" }}>
                          {inquiryData.overnight > 0
                            ? inquiryData.overnight + " over nights"
                            : inquiryData.sameDayHours + " Hours"}{" "}
                        </span>
                      </p>
                      <p className="p-tag-inquiry">
                        Pickup Date:{" "}
                        <span style={{ fontWeight: "bold", display: "block" }}>
                          {inquiryData.prefferedDate == null
                            ? ""
                            : inquiryData.prefferedDate}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </Row>
              </>
            )}
            {step === 4 && (
              <>
                <Row className="d-flex justify-content-center align-items-center gap-4">
                  <h6 style={{ textAlign: "center" }}>
                    What time would you like to depart?
                  </h6>
                  <div className="d-flex justify-content-center align-items-center gap-3">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DesktopTimePicker
                        defaultValue={
                          inquiryData.prefferedTime === null
                            ? dayjs("12:00 AM")
                            : inquiryData.prefferedTime
                        }
                        closeOnSelect={false}
	                        value={parseTimeForPicker(inquiryData.prefferedTime)}
                        onChange={(time) =>
                          handleTimeChange(time, "prefferedTime")
                        }
                        label="Preffered Time *"
                      />
	                    </LocalizationProvider>
	                  </div>
	                  <div style={{ width: "100%", maxWidth: "680px" }}>
	                    <h6 className="mb-2" style={{ textAlign: "center" }}>
	                      Available start times
	                    </h6>
	                    {availableTimeSlotsForSelectedDate.length > 0 ? (
	                      <div className="d-flex flex-wrap justify-content-center gap-2">
	                        {availableTimeSlotsForSelectedDate.map((slot) => {
	                          const selected = inquiryData.prefferedTime === slot.value;
	                          return (
	                            <Button
	                              key={slot.value}
	                              variant={selected ? "dark" : "outline-dark"}
	                              size="sm"
	                              onClick={() =>
	                                setInquiryData((prevData) => ({
	                                  ...prevData,
	                                  prefferedTime: slot.value,
	                                }))
	                              }
	                              style={{ minWidth: "96px" }}
	                            >
	                              {slot.label}
	                            </Button>
	                          );
	                        })}
	                      </div>
	                    ) : (
	                      <Alert severity="warning">
	                        No available start times for this date and duration. Please choose another date or duration.
	                      </Alert>
	                    )}
	                  </div>
	                  {lockedTimeRangesForSelectedDate.length > 0 && (
	                    <div style={{ width: "100%", maxWidth: "680px" }}>
	                      {selectedTimeConflict ? (
	                        <Alert severity="error">
	                          {getLockedTimeMessage(selectedTimeConflict)}
	                        </Alert>
	                      ) : (
	                        <Alert severity="info">
	                          <strong>Unavailable on this date:</strong>{" "}
	                          {lockedTimeRangesForSelectedDate
	                            .map((range) => `${range.start} - ${range.end}`)
	                            .join(", ")}
	                        </Alert>
	                      )}
	                    </div>
	                  )}
	                </Row>
	              </>
	            )}

            {/* Passenger Category Selector for Fishing Charter boats */}
            {step === 5 && initialData?.boatType === "Fishing Charter" && (
              <>
                <Row className="d-flex justify-content-center align-items-center gap-4">
                  <h6 style={{ textAlign: "center" }}>
                    Select number of passengers by category
                  </h6>
                  <div className="passenger-selector-container">
                    <PassengerCategorySelector
                      maxPassengers={parseInt(initialData?.pricing?.maxPassengers || 6) + parseInt(initialData?.pricing?.additionalPassengersAllowed || 10)}
                      onChange={handlePassengerCategoryChange}
                      initialValues={passengerCategories}
                    />

                    {/* Show passenger limit info */}
                    <div className="passenger-limit-info mt-2 text-muted small">
                      <p className="mb-1">Base price includes up to {initialData?.pricing?.maxPassengers || 6} passengers</p>
                      <p className="mb-0">Maximum {initialData?.pricing?.additionalPassengersAllowed || 10} additional passengers allowed (Total max: {parseInt(initialData?.pricing?.maxPassengers || 6) + parseInt(initialData?.pricing?.additionalPassengersAllowed || 10)})</p>
                    </div>

                    {/* Show additional passenger charges if applicable */}
                    {inquiryData?.additionalPassengers > 0 && (
                      <div className="additional-charges mt-3 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                        <h6>Additional Charges</h6>
                        <p className="mb-1">Base price (${inquiryData.basePrice?.toFixed(2)}) includes up to {initialData?.pricing?.maxPassengers} passengers</p>
                        <p className="mb-1">Additional passengers: {inquiryData.additionalPassengers} of {initialData?.pricing?.additionalPassengersAllowed} allowed</p>
                        <p className="mb-1">Additional charge: ${inquiryData.priceIncrease?.toFixed(2)}
                          ({initialData?.pricing?.additionalPassengerPercentage}% per passenger)</p>
                        <h5 className="mt-2">Estimated Price: ${inquiryData.adjustedPrice?.toFixed(2)}</h5>
                      </div>
                    )}
                  </div>
                </Row>
              </>
            )}

            {initialData?.boatType?.toLowerCase() === "kayak".toLowerCase() ||
              initialData?.boatType?.toLowerCase() === "Jetski".toLowerCase() ? (
              <>
                {step === 5 && (
                  <DialogTitle id="responsive-dialog-title">
                    <Form.Label className="inquiry-label">
                      Select the number of {initialData?.boatType} you want to
                      rent.
                    </Form.Label>
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <Form.Select
                        name="numberOfBoats"
                        id="numberOfBoats"
                        value={inquiryData?.numberOfBoats}
                        onChange={(e) => {
                          setInquiryData((prevData) => ({
                            ...prevData,
                            numberOfBoats: parseInt(e.target.value) || 0,
                          }));
                        }}
                        className="form-select"
                        style={{ width: "100%" }}
                        required
                      >
                        <option value="" default>
                          Select An Option
                        </option>
                        {[
                          ...Array(parseInt(initialData?.numberOfBoats) || 1),
                        ]?.map((_, i) => (
                          <option key={i} value={i + 1}>
                            {i + 1}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </DialogTitle>
                )}

                {step === 6 && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <Form.Label className="inquiry-label">
                        Adults <small>(21 and older)</small>
                      </Form.Label>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "adults", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="adults"
                          value={inquiryData.adults}
                          onChange={(e) => handleInquiryChange(e, "adults")}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "adults", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>
                      <Form.Label className="inquiry-label">
                        Seniors <small>(65 and older)</small>
                      </Form.Label>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "seniors", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="seniors"
                          value={inquiryData.seniors}
                          onChange={handleInquiryChange}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "seniors", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>
                      <Form.Label className="inquiry-label">
                        Minors <small>(Younger than 18)</small>
                      </Form.Label>

                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "children", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="children"
                          value={inquiryData.children}
                          onChange={(e) => handleInquiryChange(e, "children")}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "children", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>

                      {initialData?.boatType?.toLowerCase() ===
                        "kayak".toLowerCase() ||
                        initialData?.boatType?.toLowerCase() ===
                        "jetski".toLowerCase() ? (
                        ""
                      ) : (
                        <>
                          <Form.Label className="inquiry-label">
                            Infants <small>(Younger than 1 year old)</small>
                          </Form.Label>
                          <div className="d-flex justify-content-center align-items-center gap-3">
                            <Button
                              className="d-flex justify-content-center align-items-center"
                              style={{ width: "30px" }}
                              onClick={(e) =>
                                handleInquiryChange(e, "infants", "remove_circle")
                              }
                            >
                              <i className="material-icons add-remove">
                                remove_circle
                              </i>
                            </Button>
                            <Form.Control
                              type="number"
                              name="infants"
                              value={inquiryData.infants}
                              onChange={(e) => handleInquiryChange(e, "infants")}
                              className="form-control"
                              style={{ width: "120px" }}
                              required
                            />
                            <Button
                              className="d-flex justify-content-center align-items-center"
                              style={{ width: "30px" }}
                              onClick={(e) =>
                                handleInquiryChange(e, "infants", "add_circle")
                              }
                            >
                              <i className="material-icons add-remove">
                                add_circle
                              </i>
                            </Button>
                          </div>
                        </>
                      )}

                      <div className="mt-3">
                        {(initialData?.boatType?.toLowerCase() ===
                          "kayak".toLowerCase() ||
                          initialData?.boatType?.toLowerCase() ===
                          "jetski".toLowerCase()) &&
                          parseInt(inquiryData?.seniors) === 0 &&
                          parseInt(inquiryData?.adults) === 0 &&
                          parseInt(inquiryData?.children) > 0 && (
                            <h5
                              style={{
                                textAlign: "center",
                                marginTop: "1px",
                                padding: "5px 0 0",
                                color: "red",
                                fontSize: "12px",
                              }}
                            >
                              You must be over 18 or have a guardian to book this
                              boat.
                            </h5>
                          )}

                        {inquiryData?.adults +
                          inquiryData?.children +
                          inquiryData?.infants +
                          inquiryData?.seniors >
                          (parseInt(initialData?.capacity) || 0) *
                          inquiryData?.numberOfBoats &&
                          (initialData?.boatType?.toLowerCase() ===
                            "kayak".toLowerCase() ||
                            initialData?.boatType?.toLowerCase() ===
                            "jetski".toLowerCase()) ? (
                          <h5
                            style={{
                              textAlign: "center",
                              marginTop: "1px",
                              padding: "5px 0 0",
                              color: "red",
                              fontSize: "12px",
                            }}
                          >
                            The number of passengers exceeds the capacity of the
                            selected boat.
                          </h5>
                        ) : (
                          ""
                        )}
                      </div>

                      <h5
                        style={{
                          textAlign: "center",
                          marginTop: "20px",
                          borderTop: "1px dashed #a3aeb2",
                          padding: "13px 0 0",
                          width: "50%",
                        }}
                      >
                        Total: {toPassengerCount(inquiryData.total, "total")}
                      </h5>
                    </Row>
                  </>
                )}
                {console.log('initialData?.boatType', initialData?.boatType)}
                {step === 7 && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <h6 style={{ textAlign: "center" }}>
                        Do you have any specific needs or requests that the owner
                        needs to know?
                      </h6>
                      <TextField
                        style={{ width: "90%" }}
                        multiline
                        rows={4}
                        id="outlined-basic"
                        value={inquiryData.comments}
                        onChange={(text) =>
                          handleInquiryTextChange(text, "comments")
                        }
                        label="Comments (Optional)"
                        variant="outlined"
                      />

                      {boatTypeRequiresRenterVerification(initialData?.boatType) && (
                        <div className="d-flex mt-1 additional-box">
                          <FormControlLabel
                            style={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                checked={setAcknowledgement1}
                                onChange={() =>
                                  handleAcknowledgement("acknowledgement1")
                                }
                              />
                            }
                          />
                          <div>
                            <p style={{ fontWeight: "500", lineHeight: "28px" }}>
                              I acknowledge that the booking is subject to
                              verification and could be cancelled if its not
                              approved.
                              <span style={{ color: "red" }}>*</span>
                            </p>
                          </div>
                        </div>
                      )}

                    </Row>
                  </>
                )}

                {step === 8 && auth.currentUser === null && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <h6 style={{ textAlign: "center" }}>
                        Have an account with BBR Rentals?{" "}
                        <Link to="/auth">Sign In.</Link>
                      </h6>
                      <div className="d-flex gap-3 align-items-center justify-content-center flex-wrap">
                        <TextField
                          required
                          style={{ width: "45%" }}
                          value={signUpData.firstName}
                          onChange={(text) =>
                            handleSignUpTextChange(text, "firstName")
                          }
                          id="outlined-required"
                          label="First Name"
                        />
                        <TextField
                          required
                          style={{ width: "45%" }}
                          value={signUpData.lastName}
                          onChange={(text) =>
                            handleSignUpTextChange(text, "lastName")
                          }
                          id="outlined-required"
                          label="Last Name"
                        />
                        <TextField
                          required
                          style={{ width: "calc(90% + 1rem)" }}
                          id="outlined-required"
                          label="Email Address"
                          variant="outlined"
                          fullWidth
                          type="email"
                          value={email}
                          onChange={handleEmailChange}
                          InputProps={{
                            pattern:
                              "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}",
                          }}
                          helperText={
                            !validEmail ? "Enter a valid email address" : ""
                          }
                        />
                        <MuiTelInput
                          style={{ width: "calc(90% + 1rem)" }}
                          helperText={
                            !validPhone ? "Enter a valid phone number" : null
                          }
                          defaultCountry="US"
                          value={phone}
                          onChange={handlePhoneChange}
                        />
                      </div>
                    </Row>
                  </>
                )}

                {step === 9 && auth.currentUser === null && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <h6 style={{ textAlign: "center" }}>
                        This will create an account with Getmyboat so you can read
                        and respond to messages from owners. Passwords must be at
                        least 9 characters.
                      </h6>
                      <h6 style={{ textAlign: "center" }}>
                        Have an account with Get myboat?{" "}
                        <Link to="/auth">Sign In.</Link>
                      </h6>
                      <div className="d-flex gap-3 align-items-center justify-content-center flex-wrap">
                        <TextField
                          style={{ width: "calc(90% + 1rem)" }}
                          id="outlined-password-input"
                          value={signUpData.password}
                          onChange={(text) =>
                            handleSignUpTextChange(text, "password")
                          }
                          label="Password"
                          type="password"
                          autoComplete="current-password"
                        />
                        <TextField
                          style={{ width: "calc(90% + 1rem)" }}
                          id="outlined-confirm-password-input"
                          label="Re-enter Password"
                          type="password"
                          autoComplete="current-password"
                        />
                        {/* <Button variant="btn btn-primary" style={{width: '90%'}} onClick={nextStep}>
                Create Account
              </Button> */}
                      </div>
                    </Row>
                  </>
                )}

                {step === 10 && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <img
                        className="img-responsive mt-3 mb-3"
                        src="/inquiry-sent.png"
                        style={{ width: "120px", textAlign: "center" }}
                      />
                      <h5 style={{ textAlign: "center", lineHeight: "27px" }}>
                        We’ll contact you with options for your <br />
                        trip soon.
                      </h5>
                      <div className="d-flex gap-3 mt-3 align-items-center justify-content-center flex-wrap">
                        <Button
                          variant="btn btn-primary mt-3 p-2"
                          style={{ width: "90%" }}
                          onClick={() => {
                            if (
                              boatTypeRequiresRenterVerification(
                                initialData?.boatType
                              ) &&
                              getRenterVerificationStatus(
                                userDetails,
                                userMeta,
                                initialData?.boatType
                              ) === "unset"
                            ) {
                              Navigate("/dashboard/get-verified");
                            } else {
                              Navigate("/dashboard/inbox");
                            }
                          }}
                        >
                          Done
                        </Button>
                      </div>
                    </Row>
                  </>
                )}
              </>
            ) : (
              <>
                {(step === 5 && initialData?.boatType !== "Fishing Charter") && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <Form.Label className="inquiry-label">
                        Adults <small>(18 and older)</small>
                      </Form.Label>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "adults", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="adults"
                          value={inquiryData.adults}
                          onChange={(e) => handleInquiryChange(e, "adults")}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "adults", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>
                      <Form.Label className="inquiry-label">
                        Seniors <small>(65 and older)</small>
                      </Form.Label>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "seniors", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="seniors"
                          value={inquiryData.seniors}
                          onChange={handleInquiryChange}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "seniors", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>
                      <Form.Label className="inquiry-label">
                        Minors <small>(Younger than 18)</small>
                      </Form.Label>

                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "children", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="children"
                          value={inquiryData.children}
                          onChange={(e) => handleInquiryChange(e, "children")}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "children", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>
                      <Form.Label className="inquiry-label">
                        Infants <small>(Younger than 1 year old)</small>
                      </Form.Label>
                      <div className="d-flex justify-content-center align-items-center gap-3">
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "infants", "remove_circle")
                          }
                        >
                          <i className="material-icons add-remove">
                            remove_circle
                          </i>
                        </Button>
                        <Form.Control
                          type="number"
                          name="infants"
                          value={inquiryData.infants}
                          onChange={(e) => handleInquiryChange(e, "infants")}
                          className="form-control"
                          style={{ width: "120px" }}
                          required
                        />
                        <Button
                          className="d-flex justify-content-center align-items-center"
                          style={{ width: "30px" }}
                          onClick={(e) =>
                            handleInquiryChange(e, "infants", "add_circle")
                          }
                        >
                          <i className="material-icons add-remove">add_circle</i>
                        </Button>
                      </div>
                      <h5
                        style={{
                          textAlign: "center",
                          marginTop: "20px",
                          borderTop: "1px dashed #a3aeb2",
                          padding: "13px 0 0",
                          width: "50%",
                        }}
                      >
                        Total: {toPassengerCount(inquiryData.total, "total")}
                      </h5>
                    </Row>
                  </>
                )}

                {step === 6 && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <h6 style={{ textAlign: "center" }}>
                        Do you have any specific needs or requests that the owner
                        needs to know?
                      </h6>
                      <TextField
                        style={{ width: "90%" }}
                        multiline
                        rows={4}
                        id="outlined-basic"
                        value={inquiryData.comments}
                        onChange={(text) =>
                          handleInquiryTextChange(text, "comments")
                        }
                        label="Comments (Optional)"
                        variant="outlined"
                      />

                      {boatTypeRequiresRenterVerification(initialData?.boatType) && (
                        <div className="d-flex mt-1 additional-box">
                          <FormControlLabel
                            style={{ alignItems: "flex-start" }}
                            control={
                              <Checkbox
                                checked={setAcknowledgement1}
                                onChange={() =>
                                  handleAcknowledgement("acknowledgement1")
                                }
                              />
                            }
                          />
                          <div>
                            <p style={{ fontWeight: "500", lineHeight: "28px" }}>
                              I acknowledge that the booking is subject to
                              verification and could be cancelled if its not
                              approved.
                              <span style={{ color: "red" }}>*</span>
                            </p>
                          </div>
                        </div>
                      )}

                    </Row>
                  </>
                )}

                {step === 7 && auth.currentUser === null && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <h6 style={{ textAlign: "center" }}>
                        Have an account with BBR Rentals?{" "}
                        <Link to="/auth">Sign In.</Link>
                      </h6>
                      <div className="d-flex gap-3 align-items-center justify-content-center flex-wrap">
                        <TextField
                          required
                          style={{ width: "45%" }}
                          value={signUpData.firstName}
                          onChange={(text) =>
                            handleSignUpTextChange(text, "firstName")
                          }
                          id="outlined-required"
                          label="First Name"
                        />
                        <TextField
                          required
                          style={{ width: "45%" }}
                          value={signUpData.lastName}
                          onChange={(text) =>
                            handleSignUpTextChange(text, "lastName")
                          }
                          id="outlined-required"
                          label="Last Name"
                        />
                        <TextField
                          required
                          style={{ width: "calc(90% + 1rem)" }}
                          id="outlined-required"
                          label="Email Address"
                          variant="outlined"
                          fullWidth
                          type="email"
                          value={email}
                          onChange={handleEmailChange}
                          InputProps={{
                            pattern:
                              "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}",
                          }}
                          helperText={
                            !validEmail ? "Enter a valid email address" : ""
                          }
                        />
                        <MuiTelInput
                          style={{ width: "calc(90% + 1rem)" }}
                          helperText={
                            !validPhone ? "Enter a valid phone number" : null
                          }
                          defaultCountry="US"
                          value={phone}
                          onChange={handlePhoneChange}
                        />
                      </div>
                    </Row>
                  </>
                )}

                {step === 8 && auth.currentUser === null && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <h6 style={{ textAlign: "center" }}>
                        This will create an account with Getmyboat so you can read
                        and respond to messages from owners. Passwords must be at
                        least 9 characters.
                      </h6>
                      <h6 style={{ textAlign: "center" }}>
                        Have an account with Get myboat?{" "}
                        <Link to="/auth">Sign In.</Link>
                      </h6>
                      <div className="d-flex gap-3 align-items-center justify-content-center flex-wrap">
                        <TextField
                          style={{ width: "calc(90% + 1rem)" }}
                          id="outlined-password-input"
                          value={signUpData.password}
                          onChange={(text) =>
                            handleSignUpTextChange(text, "password")
                          }
                          label="Password"
                          type="password"
                          autoComplete="current-password"
                        />
                        <TextField
                          style={{ width: "calc(90% + 1rem)" }}
                          id="outlined-confirm-password-input"
                          label="Re-enter Password"
                          type="password"
                          autoComplete="current-password"
                        />
                        {/* <Button variant="btn btn-primary" style={{width: '90%'}} onClick={nextStep}>
                Create Account
              </Button> */}
                      </div>
                    </Row>
                  </>
                )}

                {step === 9 && (
                  <>
                    <Row className="d-flex justify-content-center align-items-center gap-4">
                      <img
                        alt="img"
                        className="img-responsive mt-3 mb-3"
                        src="/inquiry-sent.png"
                        style={{ width: "120px", textAlign: "center" }}
                      />
                      <h5 style={{ textAlign: "center", lineHeight: "27px" }}>
                        We’ll contact you with options for your <br />
                        trip soon.
                      </h5>
                      <div className="d-flex gap-3 mt-3 align-items-center justify-content-center flex-wrap">
                        <Button
                          variant="btn btn-primary mt-3 p-2"
                          style={{ width: "90%" }}
                          onClick={() => {
                            if (
                              boatTypeRequiresRenterVerification(
                                initialData?.boatType
                              ) &&
                              getRenterVerificationStatus(
                                userDetails,
                                userMeta,
                                initialData?.boatType
                              ) === "unset"
                            ) {
                              Navigate("/dashboard/get-verified");
                            } else {
                              Navigate("/dashboard/inbox");
                            }
                          }}
                        >
                          Done
                        </Button>
                      </div>
                    </Row>
                  </>
                )}
              </>
            )}
            <Col xs={12} className="text-center mt-3">
              <Row>
                <Col>
                  <h4 style={{ textAlign: "center", marginBottom: "15px", fontWeight: "600" }}>
                    Estimated Price: {`$${inquiryData.adjustedPrice?.toFixed(2) || calculateEstimatedPricing()}`}
                  </h4>
                  <div className="text-center">
                    {overnightText() && <p>{overnightText()}</p>}
                  </div>
                  <Form.Control
                    type="hidden"
                    name="arivingdatetime"
                    className="form-control"
                    required
                  />
                </Col>
              </Row>
            </Col>
          </DialogContent>

          <DialogActions className="booking-modal-btns-mobile">

            {step === 1 && (
              <>
                <Button variant="btn btn-primary" onClick={nextStep}>Next</Button>
              </>
            )}
            {step > 1 && step < 4 && (
              <>
                <Button variant="secondary" onClick={prevStep}>Back</Button>
                <Button variant="btn btn-primary" onClick={nextStep}>Next</Button>
              </>
            )}

            {step === 4 && (
              <>
                <Button variant="secondary" onClick={prevStep}>Back</Button>
                <Button
                  disabled={inquiryData?.prefferedTime === null}
                  variant="btn btn-primary"
                  onClick={nextStep}
                >
                  Next
                </Button>
              </>
            )}

            {/* Navigation buttons for passenger selection step (Fishing Charter) */}
            {step === 5 && initialData?.boatType === "Fishing Charter" && (
              <>
                <Button variant="secondary" onClick={prevStep}>Back</Button>
                <Button
                  variant="btn btn-primary"
                  onClick={nextStep}
                >
                  Next
                </Button>
              </>
            )}

            {step === 5 && initialData?.boatType?.toLowerCase() !== "fishing charter".toLowerCase() && (
              <>
                <Button variant="secondary" onClick={prevStep}>Back</Button>
                <Button variant="btn btn-primary" onClick={nextStep}>Next</Button>
              </>
            )}

            {["kayak", "jetski"].includes(initialData?.boatType?.toLowerCase()) ? (
              <>
                {step === 6 && (
                  <>
                    <Button variant="secondary" onClick={prevStep}>Back</Button>
                    <Button
                      variant="btn btn-primary"
                      className="send-inquiry"
                      onClick={() => {
                        if (
                          inquiryData?.adults +
                          inquiryData?.children +
                          inquiryData?.infants +
                          inquiryData?.seniors >
                          (parseInt(initialData?.capacity) || 0) * inquiryData?.numberOfBoats
                        ) return;

                        if (
                          parseInt(inquiryData?.seniors) === 0 &&
                          parseInt(inquiryData?.adults) === 0 &&
                          parseInt(inquiryData?.children) > 0
                        ) return;

                        nextStep();
                      }}
                    >
                      Next
                    </Button>
                    {error && <Alert severity="error">{error}</Alert>}
                  </>
                )}

                {step === 7 && (
                  <>
                    <Button variant="secondary" onClick={prevStep}>Back</Button>

                    <div className="d-flex gap-2">
                      {loading ? (
                        <Button variant="btn btn-primary">
                          <ThreeDots height="22" width="22" color="#fff" radius="20" />
                        </Button>
                      ) : (
                        <Button
                          variant="btn btn-primary"
                          className="send-inquiry"
                          onClick={() => {
                            if (auth.currentUser) {
                              sendInquiry(false, auth.currentUser.uid);
                            } else {
                              nextStep();
                            }
                          }}
                        >
                          {auth.currentUser ? "Send Inquiry" : "Next"}
                        </Button>
                      )}
                      {/* 
                    {isInstantBookAvailable && auth.currentUser && (
                      <Button
                        variant="success"
                        className="instant-book-btn"
                        onClick={handleInstantBook}
                      >
                        <i className="material-icons me-1" style={{ fontSize: '16px', verticalAlign: 'text-top' }}>flash_on</i>
                        Instant Book
                      </Button>
                    )} */}
                    </div>

                    {instantBookError && !isInstantBookAvailable && initialData?.fishingGuideDetails?.calendarRules?.instantBook && (
                      <Alert severity="info" className="mt-2">{instantBookError}</Alert>
                    )}
                    {error && <Alert severity="error">{error}</Alert>}
                  </>
                )}

                {step === 8 && (
                  <>
                    <Button variant="secondary" onClick={prevStep}>Back</Button>
                    <Button variant="btn btn-primary" onClick={nextStep}>Next</Button>
                  </>
                )}

                {step === 9 && (
                  <div>
                    <Button variant="secondary" onClick={prevStep}>Back</Button>

                    {loading ? (
                      <Button variant="btn btn-primary">
                        <ThreeDots height="22" width="22" color="#fff" radius="20" />
                      </Button>
                    ) : (
                      <Button
                        variant="btn btn-primary"
                        className="send-inquiry"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    )}

                    {error && <Alert severity="error">{error}</Alert>}
                  </div>
                )}
              </>
            ) : (
              <>
                {step === 6 && (
                  <div className="d-flex flex-column gap-2 w-100">
                    <div className="d-flex gap-2">
                      <Button variant="secondary" onClick={prevStep}>Back</Button>

                      <div className="d-flex gap-2">
                        {loading ? (
                          <Button variant="btn btn-primary">
                            <ThreeDots height="22" width="22" color="#fff" radius="20" />
                          </Button>
                        ) : (
                          <Button
                            variant="btn btn-primary"
                            className="send-inquiry"
                            onClick={() => {
                              if (auth.currentUser) {
                                sendInquiry(false, auth.currentUser.uid);
                              } else {
                                nextStep();
                              }
                            }}
                          >
                            {auth.currentUser ? "Send Inquiry" : "Next"}
                          </Button>
                        )}

                        {/* {isInstantBookAvailable && auth.currentUser && (
                        <Button
                          variant="success"
                          className="instant-book-btn"
                          onClick={handleInstantBook}
                        >
                          <i className="material-icons me-1" style={{ fontSize: '16px', verticalAlign: 'text-top' }}>flash_on</i>
                          Instant Book
                        </Button>
                      )} */}
                      </div>
                    </div>
                    {instantBookError && !isInstantBookAvailable && initialData?.fishingGuideDetails?.calendarRules?.instantBook && (
                      <Alert severity="info" className="mt-2">{instantBookError}</Alert>
                    )}
                    {error && <Alert severity="error">{error}</Alert>}
                  </div>
                )}

                {step === 7 && (
                  <>
                    <Button variant="secondary" onClick={prevStep}>Back</Button>
                    <Button variant="btn btn-primary" onClick={nextStep}>Next</Button>
                  </>
                )}

                {step === 8 && (
                  <>
                    <Button variant="secondary" onClick={prevStep}>Back</Button>

                    {loading ? (
                      <Button variant="btn btn-primary">
                        <ThreeDots height="22" width="22" color="#fff" radius="20" />
                      </Button>
                    ) : (
                      <Button
                        variant="btn btn-primary"
                        className="send-inquiry"
                        onClick={handleSubmit}
                      >
                        Submit
                      </Button>
                    )}

                    {error && <Alert severity="error">{error}</Alert>}
                  </>
                )}
              </>
            )}

          </DialogActions>

        </Dialog>

        {/* Package Instant Book Modal */}
        <PackageInstantBookModal
          open={isPackageInstantBookModalOpen}
          onClose={closePackageInstantBookModal}
          selectedPackage={selectedPackageForInstantBook}
          listing={initialData}
          currentUser={auth.currentUser}
          disabledDates={disabledDates}
          lockedDates={listingLockDatesRaw || initialData?.lockDates}
        />

        {/* Passenger selector is now integrated directly into the booking flow */}
        <Modal show={showDeleteModal} onHide={closeDeleteModal} centered dialogClassName="custom-dark-modal">
          <Modal.Header closeButton closeVariant="white" className="border-0">
            <Modal.Title style={{ color: '#ddb467' }}>Delete Review</Modal.Title>
          </Modal.Header>
          <Modal.Body className="border-0">
            Are you sure you want to delete this review? This action cannot be undone.
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="secondary" onClick={closeDeleteModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmDeleteReview}>
              Delete Review
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </LocalizationProvider>
  );
};

export default SingleListingLayout;
